(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["elitex-25l-coleccion"] && !Shopify.designMode) return;
  try {
    
/* Elitex 25 L collection. Prices, availability and images remain server-rendered. */
(() => {
  'use strict';

  if (!window.customElements || customElements.get('elitex-25l-collection')) return;

  class Elitex25Collection extends HTMLElement {
    connectedCallback() {
      if (this.connectionController && !this.connectionController.signal.aborted) return;
      this.connectionController = new AbortController();
      const signal = this.connectionController.signal;
      this.connect(signal);
    }

    disconnectedCallback() {
      if (this.connectionController) this.connectionController.abort();
    }

    async connect(signal) {
      this.grid = this.querySelector('[data-product-grid]');
      if (!this.grid) return;

      this.labels = {
        count: '{count} diseños',
        countOne: '{count} diseño',
        loading: 'Preparando todos los diseños…',
        loadError: 'No hemos podido preparar los filtros. Puedes explorar los productos a continuación.',
        noResults: 'No hay diseños con estos filtros.',
        shown: '{shown} de {total} diseños',
        loadMore: 'Ver más diseños',
        allDesigns: 'Todos los diseños',
        allFamilies: 'Todos los modelos'
      };
      const labelsNode = this.querySelector('[data-ui-labels]');
      try {
        if (labelsNode) Object.assign(this.labels, JSON.parse(labelsNode.textContent));
      } catch (_) { /* Safe defaults keep the catalogue usable if a label is malformed. */ }

      this.querySelectorAll('[data-select-design], [data-select-family]').forEach(button => { button.disabled = true; });
      this.controls = {
        family: this.querySelector('select[data-family]'),
        design: this.querySelector('select[data-design]'),
        search: this.querySelector('[data-search]'),
        stock: this.querySelector('[data-stock]'),
        sort: this.querySelector('[data-sort]')
      };

      try {
        if (!this.records) {
          this.setLoading(true);
          const cards = await this.loadAllCards(signal);
          if (signal.aborted) return;
          this.records = cards.map((element, index) => {
            const design = element.dataset.design || '';
            return {
              element,
              index,
              design,
              family: element.dataset.family || 'other',
              familyLabel: element.dataset.familyLabel || element.dataset.family || '',
              designKey: element.dataset.designKey || design,
              title: element.dataset.title || '',
              price: Number(element.dataset.price) || 0,
              available: element.dataset.available === 'true'
            };
          });
          this.designKeys = new Set(this.records.map(record => record.designKey));
          this.familyKeys = new Set(this.records.map(record => record.family));
          this.updateCatalogInfo();
        }

        if (signal.aborted) return;
        this.state = this.readURL();
        this.limit = 12;
        this.updateOptions();
        this.syncControls();
        this.bindEvents(signal);
        this.render();
        this.setLoading(false);
        this.querySelectorAll('[data-tools]').forEach(node => { node.hidden = false; });
        this.querySelectorAll('[data-server-pagination], [data-load-error]').forEach(node => { node.hidden = true; });
        this.querySelectorAll('[data-select-design], [data-select-family]').forEach(button => { button.disabled = false; });
        this.dataset.ready = 'true';
      } catch (error) {
        if (signal.aborted) return;
        this.setLoading(false);
        this.querySelectorAll('[data-tools]').forEach(node => { node.hidden = true; });
        this.querySelectorAll('[data-server-pagination]').forEach(node => { node.hidden = false; });
        const errorNode = this.querySelector('[data-load-error]');
        if (errorNode) {
          errorNode.hidden = false;
          const message = errorNode.querySelector('[data-error-message]');
          if (message) message.textContent = this.labels.loadError;
          else if (!errorNode.textContent.trim()) errorNode.textContent = this.labels.loadError;
        }
        this.querySelectorAll('[data-show-more]').forEach(node => { node.hidden = true; });
        Array.from(this.grid.querySelectorAll('[data-product-card]')).forEach(card => { card.hidden = false; });
        delete this.dataset.ready;
      }
    }

    setLoading(loading) {
      this.setAttribute('aria-busy', loading ? 'true' : 'false');
      const status = this.querySelector('[data-load-status]');
      if (status) {
        status.hidden = !loading;
        status.textContent = loading ? this.labels.loading : '';
      }
    }

    async loadAllCards(signal) {
      const initial = Array.from(this.grid.querySelectorAll('[data-product-card]'));
      const pages = Math.max(1, Number.parseInt(this.dataset.pages, 10) || 1);
      const currentPage = Math.max(1, Number.parseInt(this.dataset.page, 10) || 1);
      const expected = Number.parseInt(this.dataset.total, 10);
      const pageCards = new Map([[currentPage, initial]]);

      for (let page = 1; page <= pages; page += 1) {
        if (page === currentPage) continue;
        const url = new URL(window.location.href);
        url.searchParams.set('section_id', this.dataset.sectionId || this.id);
        url.searchParams.set(this.dataset.pageParam || 'page', String(page));
        const response = await fetch(url.toString(), {
          signal,
          credentials: 'same-origin',
          headers: { Accept: 'text/html' }
        });
        if (!response.ok) throw new Error('Could not load a catalogue page.');
        const html = await response.text();
        if (signal.aborted) throw new DOMException('Aborted', 'AbortError');
        const document = new DOMParser().parseFromString(html, 'text/html');
        const sections = Array.from(document.querySelectorAll('elitex-25l-collection'));
        const section = sections.find(node => node.dataset.sectionId === this.dataset.sectionId);
        const grid = section && section.querySelector('[data-product-grid]');
        if (!grid) throw new Error('The catalogue page was incomplete.');
        const cards = Array.from(grid.querySelectorAll('[data-product-card]'));
        if (!cards.length) throw new Error('A catalogue page contained no products.');
        pageCards.set(page, cards);
      }

      const cards = Array.from(pageCards.entries()).sort((a, b) => a[0] - b[0]).flatMap(entry => entry[1]);
      const identifiers = cards.map(card => card.dataset.id).filter(Boolean);
      if (new Set(identifiers).size !== identifiers.length) throw new Error('A catalogue page was repeated.');
      if (Number.isFinite(expected) && cards.length !== expected) throw new Error('The catalogue count changed during loading.');

      // Commit only after every page succeeds; a failure preserves the original server page.
      if (pages > 1) {
        const fragment = window.document.createDocumentFragment();
        cards.forEach(card => { fragment.appendChild(card); });
        this.grid.appendChild(fragment);
      }
      return cards;
    }

    updateCatalogInfo() {
      const available = this.records.filter(record => record.available);
      const pool = available.length ? available : this.records;
      const cheapest = pool.reduce((best, record) => !best || record.price < best.price ? record : best, null);
      const money = cheapest && cheapest.element.querySelector('[data-card-money]');
      this.querySelectorAll('[data-catalog-from]').forEach(node => {
        if (money) node.textContent = money.textContent.trim();
        else node.hidden = true;
      });
      this.querySelectorAll('[data-select-design]').forEach(button => {
        button.hidden = !this.designKeys.has(button.dataset.selectDesign);
      });
      this.querySelectorAll('[data-select-family]').forEach(button => {
        button.hidden = Boolean(button.dataset.selectFamily) && !this.familyKeys.has(button.dataset.selectFamily);
      });
    }

    defaults() {
      return { family: '', design: '', search: '', stock: false, sort: 'featured' };
    }

    readURL() {
      const params = new URL(window.location.href).searchParams;
      const state = this.defaults();
      state.family = params.get('e25_family') || '';
      state.design = params.get('e25_design') || '';
      state.search = params.get('e25_search') || '';
      state.stock = params.get('e25_stock') === '1';
      const sort = params.get('e25_sort');
      state.sort = ['featured', 'price-asc', 'price-desc', 'name'].includes(sort) ? sort : 'featured';
      return state;
    }

    writeURL() {
      const url = new URL(window.location.href);
      const values = {
        e25_family: this.state.family,
        e25_design: this.state.design,
        e25_search: this.state.search,
        e25_stock: this.state.stock ? '1' : '',
        e25_sort: this.state.sort === 'featured' ? '' : this.state.sort
      };
      Object.entries(values).forEach(([key, value]) => {
        if (value) url.searchParams.set(key, value);
        else url.searchParams.delete(key);
      });
      try { window.history.replaceState(window.history.state, '', url.toString()); }
      catch (_) { /* Preview sandboxes may disallow history updates. */ }
    }

    updateOptions() {
      const families = new Map();
      this.records.forEach(record => {
        if (record.family && !families.has(record.family)) families.set(record.family, record.familyLabel || record.family);
      });
      const familyOptions = Array.from(families).sort((a, b) => a[1].localeCompare(b[1], undefined, { sensitivity: 'base' }));
      this.setOptions(this.controls.family, this.labels.allFamilies, familyOptions);
      if (this.state.family && !families.has(this.state.family)) this.state.family = '';
      const designs = new Map();
      this.records.forEach(record => {
        if (record.designKey && !designs.has(record.designKey)) designs.set(record.designKey, record.design || record.designKey);
      });
      const designOptions = Array.from(designs).sort((a, b) => a[1].localeCompare(b[1], undefined, { sensitivity: 'base' }));
      this.setOptions(this.controls.design, this.labels.allDesigns, designOptions);
      if (this.state.design && !designs.has(this.state.design)) this.state.design = '';
    }

    setOptions(select, placeholder, values) {
      if (!select) return;
      const fragment = document.createDocumentFragment();
      [['', placeholder], ...values].forEach(([value, label]) => {
        const option = document.createElement('option');
        option.value = value;
        option.textContent = label;
        fragment.appendChild(option);
      });
      select.replaceChildren(fragment);
    }

    syncControls() {
      Object.entries(this.controls).forEach(([name, control]) => {
        if (!control) return;
        if (name === 'stock') control.checked = this.state.stock;
        else control.value = this.state[name];
      });
    }

    bindEvents(signal) {
      this.addEventListener('click', event => {
        const target = event.target instanceof Element ? event.target : null;
        if (!target) return;
        const family = target.closest('[data-select-family]');
        if (family && this.contains(family)) {
          event.preventDefault();
          const key = family.dataset.selectFamily;
          if (key && !this.familyKeys.has(key)) return;
          this.state.family = this.state.family === key ? '' : key;
          this.syncControls();
          this.change();
          return;
        }
        const design = target.closest('[data-select-design]');
        if (design && this.contains(design)) {
          event.preventDefault();
          const key = design.dataset.selectDesign;
          if (!this.designKeys.has(key)) return;
          this.state.design = this.state.design === key ? '' : key;
          this.syncControls();
          this.change();
          return;
        }
        if (target.closest('[data-reset]')) {
          event.preventDefault();
          this.state = this.defaults();
          this.updateOptions();
          this.syncControls();
          this.change();
          return;
        }
        if (target.closest('[data-show-more]')) {
          event.preventDefault();
          this.limit += 12;
          this.render();
        }
      }, { signal });

      Object.entries(this.controls).forEach(([name, control]) => {
        if (!control) return;
        control.addEventListener(name === 'search' ? 'input' : 'change', () => {
          this.state[name] = name === 'stock' ? control.checked : control.value;
          this.change();
        }, { signal });
      });

      window.addEventListener('popstate', () => {
        this.state = this.readURL();
        this.limit = 12;
        this.updateOptions();
        this.syncControls();
        this.render();
      }, { signal });
    }

    change() {
      this.limit = 12;
      this.render();
      this.writeURL();
    }

    normalize(value) {
      return String(value).normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase().trim();
    }

    format(template, values) {
      return String(template).replace(/\{(\w+)\}/g, (match, key) => Object.hasOwn(values, key) ? String(values[key]) : match);
    }

    render() {
      const state = this.state;
      const terms = this.normalize(state.search).split(/\s+/).filter(Boolean);
      const matches = this.records.filter(record => {
        if (state.family && record.family !== state.family) return false;
        if (state.design && record.designKey !== state.design) return false;
        if (state.stock && !record.available) return false;
        if (terms.length) {
          const text = this.normalize(`${record.title} ${record.familyLabel} ${record.design} ${record.designKey}`);
          if (!terms.every(term => text.includes(term))) return false;
        }
        return true;
      });
      matches.sort((a, b) => {
        if (state.sort === 'price-asc') return a.price - b.price || a.index - b.index;
        if (state.sort === 'price-desc') return b.price - a.price || a.index - b.index;
        if (state.sort === 'name') return a.title.localeCompare(b.title, undefined, { sensitivity: 'base', numeric: true }) || a.index - b.index;
        return Number(b.available) - Number(a.available) || a.index - b.index;
      });

      const visible = new Set(matches.slice(0, this.limit));
      const matchSet = new Set(matches);
      const fragment = document.createDocumentFragment();
      [...matches, ...this.records.filter(record => !matchSet.has(record))].forEach(record => {
        record.element.hidden = !visible.has(record);
        fragment.appendChild(record.element);
      });
      this.grid.appendChild(fragment);

      const count = this.querySelector('[data-result-count]');
      if (count) count.textContent = this.format(matches.length === 1 ? this.labels.countOne : this.labels.count, { count: matches.length });
      const progress = this.querySelector('[data-progress]');
      if (progress) progress.textContent = this.format(this.labels.shown, { shown: visible.size, total: matches.length });
      const more = this.querySelector('[data-show-more]');
      if (more) more.hidden = visible.size >= matches.length;
      const empty = this.querySelector('[data-empty]');
      if (empty) {
        empty.hidden = matches.length !== 0;
        const message = empty.querySelector('[data-empty-message]');
        if (message) message.textContent = this.labels.noResults;
      }

      this.querySelectorAll('[data-select-family]').forEach(button => {
        const selected = button.dataset.selectFamily === state.family;
        button.setAttribute('aria-pressed', selected ? 'true' : 'false');
        button.classList.toggle('is-active', selected);
      });
      this.querySelectorAll('[data-select-design]').forEach(button => {
        const selected = button.dataset.selectDesign === state.design;
        button.setAttribute('aria-pressed', selected ? 'true' : 'false');
        button.classList.toggle('is-active', selected);
      });
    }
  }

  customElements.define('elitex-25l-collection', Elitex25Collection);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elitex-accesorios-coleccion"] && !Shopify.designMode) return;
  try {
    
/* Elitex accessories collection. Prices, availability and images remain server-rendered. */
(() => {
  'use strict';

  if (!window.customElements || customElements.get('elitex-accessories-collection')) return;

  class ElitexAccessoriesCollection extends HTMLElement {
    connectedCallback() {
      if (this.connectionController && !this.connectionController.signal.aborted) return;
      this.connectionController = new AbortController();
      const signal = this.connectionController.signal;
      this.connect(signal);
    }

    disconnectedCallback() {
      if (this.connectionController) this.connectionController.abort();
    }

    async connect(signal) {
      this.grid = this.querySelector('[data-product-grid]');
      if (!this.grid) return;

      this.labels = {
        count: '{count} productos',
        countOne: '{count} producto',
        loading: 'Preparando el catálogo…',
        loadError: 'No hemos podido preparar los filtros. Puedes explorar los productos a continuación.',
        noResults: 'No hay productos con estos filtros.',
        shown: '{shown} de {total} productos',
        loadMore: 'Ver más productos',
        allDesigns: 'Todos los usos',
        allFamilies: 'Todos los tipos'
      };
      const labelsNode = this.querySelector('[data-ui-labels]');
      try {
        if (labelsNode) Object.assign(this.labels, JSON.parse(labelsNode.textContent));
      } catch (_) { /* Safe defaults keep the catalogue usable if a label is malformed. */ }

      this.querySelectorAll('[data-select-design], [data-select-family]').forEach(button => { button.disabled = true; });
      this.controls = {
        family: this.querySelector('select[data-family]'),
        design: this.querySelector('select[data-design]'),
        search: this.querySelector('[data-search]'),
        stock: this.querySelector('[data-stock]'),
        sort: this.querySelector('[data-sort]')
      };

      try {
        if (!this.records) {
          this.setLoading(true);
          const cards = await this.loadAllCards(signal);
          if (signal.aborted) return;
          this.records = cards.map((element, index) => {
            const design = element.dataset.design || '';
            return {
              element,
              index,
              design,
              family: element.dataset.family || 'other',
              familyLabel: element.dataset.familyLabel || element.dataset.family || '',
              designKey: element.dataset.designKey || design,
              title: element.dataset.title || '',
              variantText: element.dataset.variantSearch || '',
              price: Number(element.dataset.price) || 0,
              available: element.dataset.available === 'true'
            };
          });
          const priorities = ['cover','panel','patch','reflective','keychain','buckle','pins','other'];
          const rounds = new Map();
          this.records.forEach(record => {
            const key = `${record.available}:${record.family}`;
            const round = rounds.get(key) || 0;
            rounds.set(key, round + 1);
            const priority = priorities.indexOf(record.family);
            record.featuredRank = round * priorities.length + (priority < 0 ? priorities.length : priority);
          });
          this.designKeys = new Set(this.records.map(record => record.designKey));
          this.familyKeys = new Set(this.records.map(record => record.family));
          this.updateCatalogInfo();
        }

        if (signal.aborted) return;
        this.state = this.readURL();
        this.limit = 12;
        this.updateOptions();
        this.syncControls();
        this.bindEvents(signal);
        this.render();
        this.setLoading(false);
        this.querySelectorAll('[data-tools]').forEach(node => { node.hidden = false; });
        this.querySelectorAll('[data-server-pagination], [data-load-error]').forEach(node => { node.hidden = true; });
        this.querySelectorAll('[data-select-design], [data-select-family]').forEach(button => { button.disabled = false; });
        this.dataset.ready = 'true';
      } catch (error) {
        if (signal.aborted) return;
        this.setLoading(false);
        this.querySelectorAll('[data-tools]').forEach(node => { node.hidden = true; });
        this.querySelectorAll('[data-server-pagination]').forEach(node => { node.hidden = false; });
        const errorNode = this.querySelector('[data-load-error]');
        if (errorNode) {
          errorNode.hidden = false;
          const message = errorNode.querySelector('[data-error-message]');
          if (message) message.textContent = this.labels.loadError;
          else if (!errorNode.textContent.trim()) errorNode.textContent = this.labels.loadError;
        }
        this.querySelectorAll('[data-show-more]').forEach(node => { node.hidden = true; });
        Array.from(this.grid.querySelectorAll('[data-product-card]')).forEach(card => { card.hidden = false; });
        delete this.dataset.ready;
      }
    }

    setLoading(loading) {
      this.setAttribute('aria-busy', loading ? 'true' : 'false');
      const status = this.querySelector('[data-load-status]');
      if (status) {
        status.hidden = !loading;
        status.textContent = loading ? this.labels.loading : '';
      }
    }

    async loadAllCards(signal) {
      const initial = Array.from(this.grid.querySelectorAll('[data-product-card]'));
      const pages = Math.max(1, Number.parseInt(this.dataset.pages, 10) || 1);
      const currentPage = Math.max(1, Number.parseInt(this.dataset.page, 10) || 1);
      const expected = Number.parseInt(this.dataset.total, 10);
      const pageCards = new Map([[currentPage, initial]]);

      for (let page = 1; page <= pages; page += 1) {
        if (page === currentPage) continue;
        const url = new URL(window.location.href);
        url.searchParams.set('section_id', this.dataset.sectionId || this.id);
        url.searchParams.set(this.dataset.pageParam || 'page', String(page));
        const response = await fetch(url.toString(), {
          signal,
          credentials: 'same-origin',
          headers: { Accept: 'text/html' }
        });
        if (!response.ok) throw new Error('Could not load a catalogue page.');
        const html = await response.text();
        if (signal.aborted) throw new DOMException('Aborted', 'AbortError');
        const document = new DOMParser().parseFromString(html, 'text/html');
        const sections = Array.from(document.querySelectorAll('elitex-accessories-collection'));
        const section = sections.find(node => node.dataset.sectionId === this.dataset.sectionId);
        const grid = section && section.querySelector('[data-product-grid]');
        if (!grid) throw new Error('The catalogue page was incomplete.');
        const cards = Array.from(grid.querySelectorAll('[data-product-card]'));
        if (!cards.length) throw new Error('A catalogue page contained no products.');
        pageCards.set(page, cards);
      }

      const cards = Array.from(pageCards.entries()).sort((a, b) => a[0] - b[0]).flatMap(entry => entry[1]);
      const identifiers = cards.map(card => card.dataset.id).filter(Boolean);
      if (new Set(identifiers).size !== identifiers.length) throw new Error('A catalogue page was repeated.');
      if (Number.isFinite(expected) && cards.length !== expected) throw new Error('The catalogue count changed during loading.');

      // Commit only after every page succeeds; a failure preserves the original server page.
      if (pages > 1) {
        const fragment = window.document.createDocumentFragment();
        cards.forEach(card => { fragment.appendChild(card); });
        this.grid.appendChild(fragment);
      }
      return cards;
    }

    updateCatalogInfo() {
      const available = this.records.filter(record => record.available);
      const pool = available.length ? available : this.records;
      const cheapest = pool.reduce((best, record) => !best || record.price < best.price ? record : best, null);
      const money = cheapest && cheapest.element.querySelector('[data-card-money]');
      this.querySelectorAll('[data-catalog-from]').forEach(node => {
        if (money) node.textContent = money.textContent.trim();
        else node.hidden = true;
      });
      this.querySelectorAll('[data-select-design]').forEach(button => {
        button.hidden = !this.designKeys.has(button.dataset.selectDesign);
      });
      this.querySelectorAll('[data-select-family]').forEach(button => {
        button.hidden = Boolean(button.dataset.selectFamily) && !this.familyKeys.has(button.dataset.selectFamily);
      });
    }

    defaults() {
      return { family: '', design: '', search: '', stock: false, sort: 'featured' };
    }

    readURL() {
      const params = new URL(window.location.href).searchParams;
      const state = this.defaults();
      state.family = params.get('eacc_family') || '';
      state.design = params.get('eacc_use') || '';
      state.search = params.get('eacc_search') || '';
      state.stock = params.get('eacc_stock') === '1';
      const sort = params.get('eacc_sort');
      state.sort = ['featured', 'price-asc', 'price-desc', 'name'].includes(sort) ? sort : 'featured';
      return state;
    }

    writeURL() {
      const url = new URL(window.location.href);
      const values = {
        eacc_family: this.state.family,
        eacc_use: this.state.design,
        eacc_search: this.state.search,
        eacc_stock: this.state.stock ? '1' : '',
        eacc_sort: this.state.sort === 'featured' ? '' : this.state.sort
      };
      Object.entries(values).forEach(([key, value]) => {
        if (value) url.searchParams.set(key, value);
        else url.searchParams.delete(key);
      });
      try { window.history.replaceState(window.history.state, '', url.toString()); }
      catch (_) { /* Preview sandboxes may disallow history updates. */ }
    }

    updateOptions() {
      const families = new Map();
      this.records.forEach(record => {
        if (record.family && !families.has(record.family)) families.set(record.family, record.familyLabel || record.family);
      });
      const familyOptions = Array.from(families).sort((a, b) => a[1].localeCompare(b[1], undefined, { sensitivity: 'base' }));
      this.setOptions(this.controls.family, this.labels.allFamilies, familyOptions);
      if (this.state.family && !families.has(this.state.family)) this.state.family = '';
      const designs = new Map();
      this.records.forEach(record => {
        if (record.designKey && !designs.has(record.designKey)) designs.set(record.designKey, record.design || record.designKey);
      });
      const designOptions = Array.from(designs).sort((a, b) => a[1].localeCompare(b[1], undefined, { sensitivity: 'base' }));
      this.setOptions(this.controls.design, this.labels.allDesigns, designOptions);
      if (this.state.design && !designs.has(this.state.design)) this.state.design = '';
    }

    setOptions(select, placeholder, values) {
      if (!select) return;
      const fragment = document.createDocumentFragment();
      [['', placeholder], ...values].forEach(([value, label]) => {
        const option = document.createElement('option');
        option.value = value;
        option.textContent = label;
        fragment.appendChild(option);
      });
      select.replaceChildren(fragment);
    }

    syncControls() {
      Object.entries(this.controls).forEach(([name, control]) => {
        if (!control) return;
        if (name === 'stock') control.checked = this.state.stock;
        else control.value = this.state[name];
      });
    }

    bindEvents(signal) {
      this.addEventListener('click', event => {
        const target = event.target instanceof Element ? event.target : null;
        if (!target) return;
        const family = target.closest('[data-select-family]');
        if (family && this.contains(family)) {
          event.preventDefault();
          const key = family.dataset.selectFamily;
          if (key && !this.familyKeys.has(key)) return;
          this.state.family = this.state.family === key ? '' : key;
          this.syncControls();
          this.change();
          return;
        }
        const design = target.closest('[data-select-design]');
        if (design && this.contains(design)) {
          event.preventDefault();
          const key = design.dataset.selectDesign;
          if (!this.designKeys.has(key)) return;
          this.state.design = this.state.design === key ? '' : key;
          this.syncControls();
          this.change();
          return;
        }
        if (target.closest('[data-reset]')) {
          event.preventDefault();
          this.state = this.defaults();
          this.updateOptions();
          this.syncControls();
          this.change();
          return;
        }
        if (target.closest('[data-show-more]')) {
          event.preventDefault();
          this.limit += 12;
          this.render();
        }
      }, { signal });

      Object.entries(this.controls).forEach(([name, control]) => {
        if (!control) return;
        control.addEventListener(name === 'search' ? 'input' : 'change', () => {
          this.state[name] = name === 'stock' ? control.checked : control.value;
          this.change();
        }, { signal });
      });

      window.addEventListener('popstate', () => {
        this.state = this.readURL();
        this.limit = 12;
        this.updateOptions();
        this.syncControls();
        this.render();
      }, { signal });
    }

    change() {
      this.limit = 12;
      this.render();
      this.writeURL();
    }

    normalize(value) {
      return String(value).normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase().trim();
    }

    format(template, values) {
      return String(template).replace(/\{(\w+)\}/g, (match, key) => Object.hasOwn(values, key) ? String(values[key]) : match);
    }

    render() {
      const state = this.state;
      const terms = this.normalize(state.search).split(/\s+/).filter(Boolean);
      const matches = this.records.filter(record => {
        if (state.family && record.family !== state.family) return false;
        if (state.design && record.designKey !== state.design) return false;
        if (state.stock && !record.available) return false;
        if (terms.length) {
          const text = this.normalize(`${record.title} ${record.variantText} ${record.familyLabel} ${record.design} ${record.designKey}`);
          if (!terms.every(term => text.includes(term))) return false;
        }
        return true;
      });
      matches.sort((a, b) => {
        if (state.sort === 'price-asc') return a.price - b.price || a.index - b.index;
        if (state.sort === 'price-desc') return b.price - a.price || a.index - b.index;
        if (state.sort === 'name') return a.title.localeCompare(b.title, undefined, { sensitivity: 'base', numeric: true }) || a.index - b.index;
        return Number(b.available) - Number(a.available) || a.featuredRank - b.featuredRank || a.index - b.index;
      });

      const visible = new Set(matches.slice(0, this.limit));
      const matchSet = new Set(matches);
      const fragment = document.createDocumentFragment();
      [...matches, ...this.records.filter(record => !matchSet.has(record))].forEach(record => {
        record.element.hidden = !visible.has(record);
        fragment.appendChild(record.element);
      });
      this.grid.appendChild(fragment);

      const count = this.querySelector('[data-result-count]');
      if (count) count.textContent = this.format(matches.length === 1 ? this.labels.countOne : this.labels.count, { count: matches.length });
      const progress = this.querySelector('[data-progress]');
      if (progress) progress.textContent = this.format(this.labels.shown, { shown: visible.size, total: matches.length });
      const more = this.querySelector('[data-show-more]');
      if (more) more.hidden = visible.size >= matches.length;
      const empty = this.querySelector('[data-empty]');
      if (empty) {
        empty.hidden = matches.length !== 0;
        const message = empty.querySelector('[data-empty-message]');
        if (message) message.textContent = this.labels.noResults;
      }

      this.querySelectorAll('[data-select-family]').forEach(button => {
        const selected = button.dataset.selectFamily === state.family;
        button.setAttribute('aria-pressed', selected ? 'true' : 'false');
        button.classList.toggle('is-active', selected);
      });
      this.querySelectorAll('[data-select-design]').forEach(button => {
        const selected = button.dataset.selectDesign === state.design;
        button.setAttribute('aria-pressed', selected ? 'true' : 'false');
        button.classList.toggle('is-active', selected);
      });
    }
  }

  customElements.define('elitex-accessories-collection', ElitexAccessoriesCollection);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elitex-boonie-coleccion"] && !Shopify.designMode) return;
  try {
    
/* Elitex boonie collection. Prices, availability and images remain server-rendered. */
(() => {
  'use strict';

  if (!window.customElements || customElements.get('elitex-boonie-collection')) return;

  class ElitexBoonieCollection extends HTMLElement {
    connectedCallback() {
      if (this.connectionController && !this.connectionController.signal.aborted) return;
      this.connectionController = new AbortController();
      const signal = this.connectionController.signal;
      this.connect(signal);
    }

    disconnectedCallback() {
      if (this.connectionController) this.connectionController.abort();
    }

    async connect(signal) {
      this.grid = this.querySelector('[data-product-grid]');
      if (!this.grid) return;

      this.labels = {
        count: '{count} productos',
        countOne: '{count} producto',
        loading: 'Preparando el catálogo…',
        loadError: 'No hemos podido preparar los filtros. Puedes explorar los productos a continuación.',
        noResults: 'No hay productos con estos filtros.',
        shown: '{shown} de {total} productos',
        loadMore: 'Ver más productos',
        allDesigns: 'Todos los usos',
        allFamilies: 'Todos los tipos'
      };
      const labelsNode = this.querySelector('[data-ui-labels]');
      try {
        if (labelsNode) Object.assign(this.labels, JSON.parse(labelsNode.textContent));
      } catch (_) { /* Safe defaults keep the catalogue usable if a label is malformed. */ }

      this.querySelectorAll('[data-select-design], [data-select-family]').forEach(button => { button.disabled = true; });
      this.controls = {
        family: this.querySelector('select[data-family]'),
        design: this.querySelector('select[data-design]'),
        search: this.querySelector('[data-search]'),
        stock: this.querySelector('[data-stock]'),
        sort: this.querySelector('[data-sort]')
      };

      try {
        if (!this.records) {
          this.setLoading(true);
          const cards = await this.loadAllCards(signal);
          if (signal.aborted) return;
          this.records = cards.map((element, index) => {
            const design = element.dataset.design || '';
            return {
              element,
              index,
              design,
              family: element.dataset.family || 'other',
              familyLabel: element.dataset.familyLabel || element.dataset.family || '',
              designKey: element.dataset.designKey || design,
              title: element.dataset.title || '',
              variantText: element.dataset.variantSearch || '',
              price: Number(element.dataset.price) || 0,
              available: element.dataset.available === 'true'
            };
          });
          const priorities = ['boonie','aeroflow','other'];
          const rounds = new Map();
          this.records.forEach(record => {
            const key = record.family;
            const round = rounds.get(key) || 0;
            rounds.set(key, round + 1);
            const priority = priorities.indexOf(record.family);
            record.featuredRank = round * priorities.length + (priority < 0 ? priorities.length : priority);
          });
          this.designKeys = new Set(this.records.map(record => record.designKey));
          this.familyKeys = new Set(this.records.map(record => record.family));
          this.updateCatalogInfo();
        }

        if (signal.aborted) return;
        this.state = this.readURL();
        this.limit = 12;
        this.updateOptions();
        this.syncControls();
        this.bindEvents(signal);
        this.render();
        this.setLoading(false);
        this.querySelectorAll('[data-tools]').forEach(node => { node.hidden = false; });
        this.querySelectorAll('[data-server-pagination], [data-load-error]').forEach(node => { node.hidden = true; });
        this.querySelectorAll('[data-select-design], [data-select-family]').forEach(button => { button.disabled = false; });
        this.dataset.ready = 'true';
      } catch (error) {
        if (signal.aborted) return;
        this.setLoading(false);
        this.querySelectorAll('[data-tools]').forEach(node => { node.hidden = true; });
        this.querySelectorAll('[data-server-pagination]').forEach(node => { node.hidden = false; });
        const errorNode = this.querySelector('[data-load-error]');
        if (errorNode) {
          errorNode.hidden = false;
          const message = errorNode.querySelector('[data-error-message]');
          if (message) message.textContent = this.labels.loadError;
          else if (!errorNode.textContent.trim()) errorNode.textContent = this.labels.loadError;
        }
        this.querySelectorAll('[data-show-more]').forEach(node => { node.hidden = true; });
        Array.from(this.grid.querySelectorAll('[data-product-card]')).forEach(card => { card.hidden = false; });
        delete this.dataset.ready;
      }
    }

    setLoading(loading) {
      this.setAttribute('aria-busy', loading ? 'true' : 'false');
      const status = this.querySelector('[data-load-status]');
      if (status) {
        status.hidden = !loading;
        status.textContent = loading ? this.labels.loading : '';
      }
    }

    async loadAllCards(signal) {
      const initial = Array.from(this.grid.querySelectorAll('[data-product-card]'));
      const pages = Math.max(1, Number.parseInt(this.dataset.pages, 10) || 1);
      const currentPage = Math.max(1, Number.parseInt(this.dataset.page, 10) || 1);
      const expected = Number.parseInt(this.dataset.total, 10);
      const pageCards = new Map([[currentPage, initial]]);

      for (let page = 1; page <= pages; page += 1) {
        if (page === currentPage) continue;
        const url = new URL(window.location.href);
        url.searchParams.set('section_id', this.dataset.sectionId || this.id);
        url.searchParams.set(this.dataset.pageParam || 'page', String(page));
        const response = await fetch(url.toString(), {
          signal,
          credentials: 'same-origin',
          headers: { Accept: 'text/html' }
        });
        if (!response.ok) throw new Error('Could not load a catalogue page.');
        const html = await response.text();
        if (signal.aborted) throw new DOMException('Aborted', 'AbortError');
        const document = new DOMParser().parseFromString(html, 'text/html');
        const sections = Array.from(document.querySelectorAll('elitex-boonie-collection'));
        const section = sections.find(node => node.dataset.sectionId === this.dataset.sectionId);
        const grid = section && section.querySelector('[data-product-grid]');
        if (!grid) throw new Error('The catalogue page was incomplete.');
        const cards = Array.from(grid.querySelectorAll('[data-product-card]'));
        if (!cards.length) throw new Error('A catalogue page contained no products.');
        pageCards.set(page, cards);
      }

      const cards = Array.from(pageCards.entries()).sort((a, b) => a[0] - b[0]).flatMap(entry => entry[1]);
      const identifiers = cards.map(card => card.dataset.id).filter(Boolean);
      if (new Set(identifiers).size !== identifiers.length) throw new Error('A catalogue page was repeated.');
      if (Number.isFinite(expected) && cards.length !== expected) throw new Error('The catalogue count changed during loading.');

      // Commit only after every page succeeds; a failure preserves the original server page.
      if (pages > 1) {
        const fragment = window.document.createDocumentFragment();
        cards.forEach(card => { fragment.appendChild(card); });
        this.grid.appendChild(fragment);
      }
      return cards;
    }

    updateCatalogInfo() {
      const available = this.records.filter(record => record.available);
      const pool = available.length ? available : this.records;
      const cheapest = pool.reduce((best, record) => !best || record.price < best.price ? record : best, null);
      const money = cheapest && cheapest.element.querySelector('[data-card-money]');
      this.querySelectorAll('[data-catalog-from]').forEach(node => {
        if (money) node.textContent = money.textContent.trim();
        else node.hidden = true;
      });
      this.querySelectorAll('[data-select-design]').forEach(button => {
        button.hidden = !this.designKeys.has(button.dataset.selectDesign);
      });
      this.querySelectorAll('[data-select-family]').forEach(button => {
        button.hidden = Boolean(button.dataset.selectFamily) && !this.familyKeys.has(button.dataset.selectFamily);
      });
    }

    defaults() {
      return { family: '', design: '', search: '', stock: false, sort: 'featured' };
    }

    readURL() {
      const params = new URL(window.location.href).searchParams;
      const state = this.defaults();
      state.family = params.get('ebc_family') || '';
      state.design = params.get('ebc_use') || '';
      state.search = params.get('ebc_search') || '';
      state.stock = params.get('ebc_stock') === '1';
      const sort = params.get('ebc_sort');
      state.sort = ['featured', 'price-asc', 'price-desc', 'name'].includes(sort) ? sort : 'featured';
      return state;
    }

    writeURL() {
      const url = new URL(window.location.href);
      const values = {
        ebc_family: this.state.family,
        ebc_use: this.state.design,
        ebc_search: this.state.search,
        ebc_stock: this.state.stock ? '1' : '',
        ebc_sort: this.state.sort === 'featured' ? '' : this.state.sort
      };
      Object.entries(values).forEach(([key, value]) => {
        if (value) url.searchParams.set(key, value);
        else url.searchParams.delete(key);
      });
      try { window.history.replaceState(window.history.state, '', url.toString()); }
      catch (_) { /* Preview sandboxes may disallow history updates. */ }
    }

    updateOptions() {
      const families = new Map();
      this.records.forEach(record => {
        if (record.family && !families.has(record.family)) families.set(record.family, record.familyLabel || record.family);
      });
      const familyOptions = Array.from(families).sort((a, b) => a[1].localeCompare(b[1], undefined, { sensitivity: 'base' }));
      this.setOptions(this.controls.family, this.labels.allFamilies, familyOptions);
      if (this.state.family && !families.has(this.state.family)) this.state.family = '';
      const designs = new Map();
      this.records.forEach(record => {
        if (record.designKey && !designs.has(record.designKey)) designs.set(record.designKey, record.design || record.designKey);
      });
      const designOptions = Array.from(designs).sort((a, b) => a[1].localeCompare(b[1], undefined, { sensitivity: 'base' }));
      this.setOptions(this.controls.design, this.labels.allDesigns, designOptions);
      if (this.state.design && !designs.has(this.state.design)) this.state.design = '';
    }

    setOptions(select, placeholder, values) {
      if (!select) return;
      const fragment = document.createDocumentFragment();
      [['', placeholder], ...values].forEach(([value, label]) => {
        const option = document.createElement('option');
        option.value = value;
        option.textContent = label;
        fragment.appendChild(option);
      });
      select.replaceChildren(fragment);
    }

    syncControls() {
      Object.entries(this.controls).forEach(([name, control]) => {
        if (!control) return;
        if (name === 'stock') control.checked = this.state.stock;
        else control.value = this.state[name];
      });
    }

    bindEvents(signal) {
      this.addEventListener('click', event => {
        const target = event.target instanceof Element ? event.target : null;
        if (!target) return;
        const family = target.closest('[data-select-family]');
        if (family && this.contains(family)) {
          event.preventDefault();
          const key = family.dataset.selectFamily;
          if (key && !this.familyKeys.has(key)) return;
          this.state.family = key;
          this.state.search = '';
          this.state.design = '';
          if (!key) this.state.stock = false;
          this.syncControls();
          this.change();
          return;
        }
        const design = target.closest('[data-select-design]');
        if (design && this.contains(design)) {
          event.preventDefault();
          const key = design.dataset.selectDesign;
          if (!this.designKeys.has(key)) return;
          this.state.design = this.state.design === key ? '' : key;
          this.syncControls();
          this.change();
          return;
        }
        if (target.closest('[data-reset]')) {
          event.preventDefault();
          this.state = this.defaults();
          this.updateOptions();
          this.syncControls();
          this.change();
          return;
        }
        if (target.closest('[data-show-more]')) {
          event.preventDefault();
          this.limit += 12;
          this.render();
        }
      }, { signal });

      Object.entries(this.controls).forEach(([name, control]) => {
        if (!control) return;
        control.addEventListener(name === 'search' ? 'input' : 'change', () => {
          this.state[name] = name === 'stock' ? control.checked : control.value;
          this.change();
        }, { signal });
      });

      window.addEventListener('popstate', () => {
        this.state = this.readURL();
        this.limit = 12;
        this.updateOptions();
        this.syncControls();
        this.render();
      }, { signal });
    }

    change() {
      this.limit = 12;
      this.render();
      this.writeURL();
    }

    normalize(value) {
      return String(value).normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase().trim();
    }

    format(template, values) {
      return String(template).replace(/\{(\w+)\}/g, (match, key) => Object.hasOwn(values, key) ? String(values[key]) : match);
    }

    render() {
      const state = this.state;
      const terms = this.normalize(state.search).split(/\s+/).filter(Boolean);
      const matches = this.records.filter(record => {
        if (state.family && record.family !== state.family) return false;
        if (state.design && record.designKey !== state.design) return false;
        if (state.stock && !record.available) return false;
        if (terms.length) {
          const text = this.normalize(`${record.title} ${record.variantText} ${record.familyLabel} ${record.design} ${record.designKey}`);
          if (!terms.every(term => text.includes(term))) return false;
        }
        return true;
      });
      matches.sort((a, b) => {
        if (state.sort === 'price-asc') return a.price - b.price || a.index - b.index;
        if (state.sort === 'price-desc') return b.price - a.price || a.index - b.index;
        if (state.sort === 'name') return a.title.localeCompare(b.title, undefined, { sensitivity: 'base', numeric: true }) || a.index - b.index;
        return a.featuredRank - b.featuredRank || a.index - b.index;
      });

      const visible = new Set(matches.slice(0, this.limit));
      const matchSet = new Set(matches);
      const fragment = document.createDocumentFragment();
      [...matches, ...this.records.filter(record => !matchSet.has(record))].forEach(record => {
        record.element.hidden = !visible.has(record);
        fragment.appendChild(record.element);
      });
      this.grid.appendChild(fragment);

      const count = this.querySelector('[data-result-count]');
      if (count) count.textContent = this.format(matches.length === 1 ? this.labels.countOne : this.labels.count, { count: matches.length });
      const progress = this.querySelector('[data-progress]');
      if (progress) progress.textContent = this.format(this.labels.shown, { shown: visible.size, total: matches.length });
      const more = this.querySelector('[data-show-more]');
      if (more) more.hidden = visible.size >= matches.length;
      const empty = this.querySelector('[data-empty]');
      if (empty) {
        empty.hidden = matches.length !== 0;
        const message = empty.querySelector('[data-empty-message]');
        if (message) message.textContent = this.labels.noResults;
      }

      this.querySelectorAll('[data-select-family]').forEach(button => {
        const selected = button.dataset.selectFamily === state.family;
        button.setAttribute('aria-pressed', selected ? 'true' : 'false');
        button.classList.toggle('is-active', selected);
      });
      this.querySelectorAll('[data-select-design]').forEach(button => {
        const selected = button.dataset.selectDesign === state.design;
        button.setAttribute('aria-pressed', selected ? 'true' : 'false');
        button.classList.toggle('is-active', selected);
      });
    }
  }

  customElements.define('elitex-boonie-collection', ElitexBoonieCollection);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elitex-botella"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('elitex-bottles')) {
  customElements.define('elitex-bottles', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const filters = this.querySelector('.exb-filters');
      if (filters && this.querySelector('[data-color-card]')) filters.hidden = false;
      this.addEventListener('click', event => {
        const filter = event.target.closest('[data-filter]');
        if (filter && this.contains(filter)) {
          this.setFilter(filter.dataset.filter);
          return;
        }
        const link = event.target.closest('[data-exb-purchase]');
        if (!link || !this.contains(link) || this.dataset.productContext !== 'true') return;
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
        const variantIds = new Set((this.dataset.variantIds || '').trim().split(/\s+/));
        const nativeForm = Array.from(document.querySelectorAll('form[action*="/cart/add"]')).find(form => {
          const field = form.querySelector('[name="id"]');
          return field && variantIds.has(String(field.value)) && form.getClientRects().length > 0 && !this.contains(form);
        });
        if (!nativeForm) return;
        const control = Array.from(nativeForm.querySelectorAll('button[type="submit"], input[type="submit"], select, input:not([type="hidden"]):not([type="radio"]):not([type="checkbox"]), button')).find(item => !item.disabled && item.getClientRects().length > 0);
        event.preventDefault();
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        nativeForm.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'center' });
        if (control) control.focus({ preventScroll: true });
      }, { signal: this.controller.signal });
      this.addEventListener('shopify:block:select', event => {
        const card = event.target.closest('[data-color-card]');
        if (card && this.contains(card)) this.setFilter('all');
        const detail = event.target.closest('details.exb-question');
        if (detail && this.contains(detail)) detail.open = true;
      }, { signal: this.controller.signal });
    }
    setFilter(key) {
      const buttons = Array.from(this.querySelectorAll('[data-filter]'));
      if (!buttons.some(button => button.dataset.filter === key)) return;
      buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.filter === key)));
      this.querySelectorAll('[data-color-card]').forEach(card => { card.hidden = key !== 'all' && card.dataset.model !== key; });
    }
    disconnectedCallback() {
      if (this.controller) this.controller.abort();
      this.controller = null;
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elitex-calcetines-coleccion"] && !Shopify.designMode) return;
  try {
    
/* Elitex socks collection. Prices, availability and images remain server-rendered. */
(() => {
  'use strict';

  if (!window.customElements || customElements.get('elitex-socks-collection')) return;

  class ElitexSocksCollection extends HTMLElement {
    connectedCallback() {
      if (this.connectionController && !this.connectionController.signal.aborted) return;
      this.connectionController = new AbortController();
      const signal = this.connectionController.signal;
      this.connect(signal);
    }

    disconnectedCallback() {
      if (this.connectionController) this.connectionController.abort();
    }

    async connect(signal) {
      this.grid = this.querySelector('[data-product-grid]');
      if (!this.grid) return;

      this.labels = {
        count: '{count} productos',
        countOne: '{count} producto',
        loading: 'Preparando el catálogo…',
        loadError: 'No hemos podido preparar los filtros. Puedes explorar los productos a continuación.',
        noResults: 'No hay productos con estos filtros.',
        shown: '{shown} de {total} productos',
        loadMore: 'Ver más productos',
        allDesigns: 'Todos los usos',
        allFamilies: 'Todos los tipos'
      };
      const labelsNode = this.querySelector('[data-ui-labels]');
      try {
        if (labelsNode) Object.assign(this.labels, JSON.parse(labelsNode.textContent));
      } catch (_) { /* Safe defaults keep the catalogue usable if a label is malformed. */ }

      this.querySelectorAll('[data-select-design], [data-select-family]').forEach(button => { button.disabled = true; });
      this.controls = {
        family: this.querySelector('select[data-family]'),
        design: this.querySelector('select[data-design]'),
        search: this.querySelector('[data-search]'),
        stock: this.querySelector('[data-stock]'),
        sort: this.querySelector('[data-sort]')
      };

      try {
        if (!this.records) {
          this.setLoading(true);
          const cards = await this.loadAllCards(signal);
          if (signal.aborted) return;
          this.records = cards.map((element, index) => {
            const design = element.dataset.design || '';
            return {
              element,
              index,
              design,
              family: element.dataset.family || 'other',
              familyLabel: element.dataset.familyLabel || element.dataset.family || '',
              designKey: element.dataset.designKey || design,
              title: element.dataset.title || '',
              variantText: element.dataset.variantSearch || '',
              variants: JSON.parse(element.dataset.variants || '[]'),
              price: Number(element.dataset.price) || 0,
              available: element.dataset.available === 'true'
            };
          });
          const priorities = ['design','pack'];
          const rounds = new Map();
          this.records.forEach(record => {
            const key = `${record.available}:${record.family}`;
            const round = rounds.get(key) || 0;
            rounds.set(key, round + 1);
            const priority = priorities.indexOf(record.family);
            record.featuredRank = round * priorities.length + (priority < 0 ? priorities.length : priority);
          });
          this.designKeys = new Set(this.records.flatMap(record => record.variants.map(v => v.size)));
          this.familyKeys = new Set(this.records.map(record => record.family));
          this.updateCatalogInfo();
        }

        if (signal.aborted) return;
        this.state = this.readURL();
        this.limit = 12;
        this.updateOptions();
        this.syncControls();
        this.bindEvents(signal);
        this.render();
        this.setLoading(false);
        this.querySelectorAll('[data-tools]').forEach(node => { node.hidden = false; });
        this.querySelectorAll('[data-server-pagination], [data-load-error]').forEach(node => { node.hidden = true; });
        this.querySelectorAll('[data-select-design], [data-select-family]').forEach(button => { button.disabled = false; });
        this.dataset.ready = 'true';
      } catch (error) {
        if (signal.aborted) return;
        this.setLoading(false);
        this.querySelectorAll('[data-tools]').forEach(node => { node.hidden = true; });
        this.querySelectorAll('[data-server-pagination]').forEach(node => { node.hidden = false; });
        const errorNode = this.querySelector('[data-load-error]');
        if (errorNode) {
          errorNode.hidden = false;
          const message = errorNode.querySelector('[data-error-message]');
          if (message) message.textContent = this.labels.loadError;
          else if (!errorNode.textContent.trim()) errorNode.textContent = this.labels.loadError;
        }
        this.querySelectorAll('[data-show-more]').forEach(node => { node.hidden = true; });
        Array.from(this.grid.querySelectorAll('[data-product-card]')).forEach(card => { card.hidden = false; });
        delete this.dataset.ready;
      }
    }

    setLoading(loading) {
      this.setAttribute('aria-busy', loading ? 'true' : 'false');
      const status = this.querySelector('[data-load-status]');
      if (status) {
        status.hidden = !loading;
        status.textContent = loading ? this.labels.loading : '';
      }
    }

    async loadAllCards(signal) {
      const initial = Array.from(this.grid.querySelectorAll('[data-product-card]'));
      const pages = Math.max(1, Number.parseInt(this.dataset.pages, 10) || 1);
      const currentPage = Math.max(1, Number.parseInt(this.dataset.page, 10) || 1);
      const expected = Number.parseInt(this.dataset.total, 10);
      const pageCards = new Map([[currentPage, initial]]);

      for (let page = 1; page <= pages; page += 1) {
        if (page === currentPage) continue;
        const url = new URL(window.location.href);
        url.searchParams.set('section_id', this.dataset.sectionId || this.id);
        url.searchParams.set(this.dataset.pageParam || 'page', String(page));
        const response = await fetch(url.toString(), {
          signal,
          credentials: 'same-origin',
          headers: { Accept: 'text/html' }
        });
        if (!response.ok) throw new Error('Could not load a catalogue page.');
        const html = await response.text();
        if (signal.aborted) throw new DOMException('Aborted', 'AbortError');
        const document = new DOMParser().parseFromString(html, 'text/html');
        const sections = Array.from(document.querySelectorAll('elitex-socks-collection'));
        const section = sections.find(node => node.dataset.sectionId === this.dataset.sectionId);
        const grid = section && section.querySelector('[data-product-grid]');
        if (!grid) throw new Error('The catalogue page was incomplete.');
        const cards = Array.from(grid.querySelectorAll('[data-product-card]'));
        if (!cards.length) throw new Error('A catalogue page contained no products.');
        pageCards.set(page, cards);
      }

      const cards = Array.from(pageCards.entries()).sort((a, b) => a[0] - b[0]).flatMap(entry => entry[1]);
      const identifiers = cards.map(card => card.dataset.id).filter(Boolean);
      if (new Set(identifiers).size !== identifiers.length) throw new Error('A catalogue page was repeated.');
      if (Number.isFinite(expected) && cards.length !== expected) throw new Error('The catalogue count changed during loading.');

      // Commit only after every page succeeds; a failure preserves the original server page.
      if (pages > 1) {
        const fragment = window.document.createDocumentFragment();
        cards.forEach(card => { fragment.appendChild(card); });
        this.grid.appendChild(fragment);
      }
      return cards;
    }

    updateCatalogInfo() {
      const available = this.records.filter(record => record.available);
      const pool = available.length ? available : this.records;
      const cheapest = pool.reduce((best, record) => !best || record.price < best.price ? record : best, null);
      const money = cheapest && cheapest.element.querySelector('[data-card-money]');
      this.querySelectorAll('[data-catalog-from]').forEach(node => {
        if (money) node.textContent = money.textContent.trim();
        else node.hidden = true;
      });
      this.querySelectorAll('[data-select-design]').forEach(button => {
        button.hidden = !this.designKeys.has(button.dataset.selectDesign);
      });
      this.querySelectorAll('[data-select-family]').forEach(button => {
        button.hidden = Boolean(button.dataset.selectFamily) && !this.familyKeys.has(button.dataset.selectFamily);
      });
    }

    defaults() {
      return { family: '', design: '', search: '', stock: false, sort: 'featured' };
    }

    readURL() {
      const params = new URL(window.location.href).searchParams;
      const state = this.defaults();
      state.family = params.get('esock_family') || '';
      state.design = params.get('esock_size') || '';
      state.search = params.get('esock_search') || '';
      state.stock = params.get('esock_stock') === '1';
      const sort = params.get('esock_sort');
      state.sort = ['featured', 'price-asc', 'price-desc', 'name'].includes(sort) ? sort : 'featured';
      return state;
    }

    writeURL() {
      const url = new URL(window.location.href);
      const values = {
        esock_family: this.state.family,
        esock_size: this.state.design,
        esock_search: this.state.search,
        esock_stock: this.state.stock ? '1' : '',
        esock_sort: this.state.sort === 'featured' ? '' : this.state.sort
      };
      Object.entries(values).forEach(([key, value]) => {
        if (value) url.searchParams.set(key, value);
        else url.searchParams.delete(key);
      });
      try { window.history.replaceState(window.history.state, '', url.toString()); }
      catch (_) { /* Preview sandboxes may disallow history updates. */ }
    }

    updateOptions() {
      const families = new Map();
      this.records.forEach(record => {
        if (record.family && !families.has(record.family)) families.set(record.family, record.familyLabel || record.family);
      });
      const familyOptions = Array.from(families).sort((a, b) => a[1].localeCompare(b[1], undefined, { sensitivity: 'base' }));
      this.setOptions(this.controls.family, this.labels.allFamilies, familyOptions);
      if (this.state.family && !families.has(this.state.family)) this.state.family = '';
      const designs = new Map();
      this.records.forEach(record => {
        record.variants.forEach(v => designs.set(v.size, v.size));
      });
      const designOptions = Array.from(designs).sort((a, b) => a[1].localeCompare(b[1], undefined, { sensitivity: 'base' }));
      this.setOptions(this.controls.design, this.labels.allDesigns, designOptions);
      if (this.state.design && !designs.has(this.state.design)) this.state.design = '';
    }

    setOptions(select, placeholder, values) {
      if (!select) return;
      const fragment = document.createDocumentFragment();
      [['', placeholder], ...values].forEach(([value, label]) => {
        const option = document.createElement('option');
        option.value = value;
        option.textContent = label;
        fragment.appendChild(option);
      });
      select.replaceChildren(fragment);
    }

    syncControls() {
      Object.entries(this.controls).forEach(([name, control]) => {
        if (!control) return;
        if (name === 'stock') control.checked = this.state.stock;
        else control.value = this.state[name];
      });
    }

    bindEvents(signal) {
      this.addEventListener('click', event => {
        const target = event.target instanceof Element ? event.target : null;
        if (!target) return;
        const family = target.closest('[data-select-family]');
        if (family && this.contains(family)) {
          event.preventDefault();
          const key = family.dataset.selectFamily;
          if (key && !this.familyKeys.has(key)) return;
          this.state.family = this.state.family === key ? '' : key;
          this.syncControls();
          this.change();
          return;
        }
        const design = target.closest('[data-select-design]');
        if (design && this.contains(design)) {
          event.preventDefault();
          const key = design.dataset.selectDesign;
          if (!this.designKeys.has(key)) return;
          this.state.design = this.state.design === key ? '' : key;
          this.syncControls();
          this.change();
          return;
        }
        if (target.closest('[data-reset]')) {
          event.preventDefault();
          this.state = this.defaults();
          this.updateOptions();
          this.syncControls();
          this.change();
          return;
        }
        if (target.closest('[data-show-more]')) {
          event.preventDefault();
          this.limit += 12;
          this.render();
        }
      }, { signal });

      Object.entries(this.controls).forEach(([name, control]) => {
        if (!control) return;
        control.addEventListener(name === 'search' ? 'input' : 'change', () => {
          this.state[name] = name === 'stock' ? control.checked : control.value;
          this.change();
        }, { signal });
      });

      window.addEventListener('popstate', () => {
        this.state = this.readURL();
        this.limit = 12;
        this.updateOptions();
        this.syncControls();
        this.render();
      }, { signal });
    }

    change() {
      this.limit = 12;
      this.render();
      this.writeURL();
    }

    normalize(value) {
      return String(value).normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase().trim();
    }

    format(template, values) {
      return String(template).replace(/\{(\w+)\}/g, (match, key) => Object.hasOwn(values, key) ? String(values[key]) : match);
    }

    render() {
      const state = this.state;
      const terms = this.normalize(state.search).split(/\s+/).filter(Boolean);
      const matches = this.records.filter(record => {
        if (state.family && record.family !== state.family) return false;
        if (state.design && !record.variants.some(v => v.size === state.design && v.available)) return false;
        if (state.stock && !record.available) return false;
        if (terms.length) {
          const text = this.normalize(`${record.title} ${record.variantText} ${record.familyLabel} ${record.design} ${record.designKey}`);
          if (!terms.every(term => text.includes(term))) return false;
        }
        return true;
      });
      const priceFor = record => state.design ? record.variants.find(v => v.size === state.design).price : record.price;
      matches.sort((a, b) => {
        if (state.sort === 'price-asc') return priceFor(a) - priceFor(b) || a.index - b.index;
        if (state.sort === 'price-desc') return priceFor(b) - priceFor(a) || a.index - b.index;
        if (state.sort === 'name') return a.title.localeCompare(b.title, undefined, { sensitivity: 'base', numeric: true }) || a.index - b.index;
        return Number(b.available) - Number(a.available) || a.featuredRank - b.featuredRank || a.index - b.index;
      });

      this.records.forEach(record => {
        const card = record.element;
        const selected = state.design && record.variants.find(v => v.size === state.design && v.available);
        const money = card.querySelector('[data-card-money]');
        if (!record.originalMoney) record.originalMoney = money.textContent;
        money.textContent = selected ? selected.money : record.originalMoney;
        const from = card.querySelector('.sockc-from'); if (from) from.hidden = Boolean(selected);
        card.querySelectorAll('s, .sockc-badge:not(.sockc-sold)').forEach(n => { n.hidden = Boolean(selected); });
        card.querySelectorAll('a[href]').forEach(link => {
          if (!link.dataset.baseUrl) link.dataset.baseUrl = link.getAttribute('href');
          const url = new URL(link.dataset.baseUrl, window.location.href);
          if (selected) url.searchParams.set('variant', String(selected.id));
          link.setAttribute('href', selected ? url.toString() : link.dataset.baseUrl);
        });
      });
      const visible = new Set(matches.slice(0, this.limit));
      const matchSet = new Set(matches);
      const fragment = document.createDocumentFragment();
      [...matches, ...this.records.filter(record => !matchSet.has(record))].forEach(record => {
        record.element.hidden = !visible.has(record);
        fragment.appendChild(record.element);
      });
      this.grid.appendChild(fragment);

      const count = this.querySelector('[data-result-count]');
      if (count) count.textContent = this.format(matches.length === 1 ? this.labels.countOne : this.labels.count, { count: matches.length });
      const progress = this.querySelector('[data-progress]');
      if (progress) progress.textContent = this.format(this.labels.shown, { shown: visible.size, total: matches.length });
      const more = this.querySelector('[data-show-more]');
      if (more) more.hidden = visible.size >= matches.length;
      const empty = this.querySelector('[data-empty]');
      if (empty) {
        empty.hidden = matches.length !== 0;
        const message = empty.querySelector('[data-empty-message]');
        if (message) message.textContent = this.labels.noResults;
      }

      this.querySelectorAll('[data-select-family]').forEach(button => {
        const selected = button.dataset.selectFamily === state.family;
        button.setAttribute('aria-pressed', selected ? 'true' : 'false');
        button.classList.toggle('is-active', selected);
      });
      this.querySelectorAll('[data-select-design]').forEach(button => {
        const selected = button.dataset.selectDesign === state.design;
        button.setAttribute('aria-pressed', selected ? 'true' : 'false');
        button.classList.toggle('is-active', selected);
      });
    }
  }

  customElements.define('elitex-socks-collection', ElitexSocksCollection);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elitex-colecciones-diseno"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('elitex-design-collections')) {
  customElements.define('elitex-design-collections', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.panels = Array.from(this.querySelectorAll('[data-design-panel]'));
      this.choices = Array.from(this.querySelectorAll('[data-design-choice]'));
      if (!this.panels.length) return;
      this.controller = new AbortController();
      const controls = this.querySelector('[data-design-controls]');
      if (controls && this.choices.length > 1) controls.hidden = false;
      this.addEventListener('click', event => {
        const choice = event.target.closest('[data-design-choice]');
        if (!choice || !this.contains(choice)) return;
        this.selectDesign(choice.dataset.designChoice, true);
      }, { signal: this.controller.signal });
      this.addEventListener('shopify:block:select', event => {
        if (event.detail && event.detail.blockId) this.selectDesign(event.detail.blockId, false);
      }, { signal: this.controller.signal });
      const first = this.panels.find(panel => !panel.hidden) || this.panels[0];
      this.selectDesign(first.dataset.designPanel, false);
    }
    disconnectedCallback() {
      if (this.controller) this.controller.abort();
      this.controller = null;
    }
    selectDesign(id, announce) {
      const chosen = this.panels.find(panel => panel.dataset.designPanel === id);
      if (!chosen) return;
      this.panels.forEach(panel => { panel.hidden = panel !== chosen; });
      this.choices.forEach(choice => choice.setAttribute('aria-pressed', String(choice.dataset.designChoice === id)));
      const status = this.querySelector('[data-design-status]');
      const title = chosen.querySelector('[data-design-title]');
      if (announce && status && title) status.textContent = title.textContent.trim();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elitex-compresion-coleccion"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('elitex-compression')) {
  customElements.define('elitex-compression', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.addEventListener('shopify:block:select', event => {
        const detail = event.target.closest('details.exc-question');
        if (detail && this.contains(detail)) detail.open = true;
      }, { signal: this.controller.signal });
    }
    disconnectedCallback() {
      if (this.controller) this.controller.abort();
      this.controller = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elitex-material-coleccion"] && !Shopify.designMode) return;
  try {
    
/* Elitex material collection. Prices, availability and images remain server-rendered. */
(() => {
  'use strict';

  if (!window.customElements || customElements.get('elitex-material-collection')) return;

  class ElitexMaterialCollection extends HTMLElement {
    connectedCallback() {
      if (this.connectionController && !this.connectionController.signal.aborted) return;
      this.connectionController = new AbortController();
      const signal = this.connectionController.signal;
      this.connect(signal);
    }

    disconnectedCallback() {
      if (this.connectionController) this.connectionController.abort();
    }

    async connect(signal) {
      this.grid = this.querySelector('[data-product-grid]');
      if (!this.grid) return;

      this.labels = {
        count: '{count} productos',
        countOne: '{count} producto',
        loading: 'Preparando el catálogo…',
        loadError: 'No hemos podido preparar los filtros. Puedes explorar los productos a continuación.',
        noResults: 'No hay productos con estos filtros.',
        shown: '{shown} de {total} productos',
        loadMore: 'Ver más productos',
        allDesigns: 'Todos los usos',
        allFamilies: 'Todos los tipos'
      };
      const labelsNode = this.querySelector('[data-ui-labels]');
      try {
        if (labelsNode) Object.assign(this.labels, JSON.parse(labelsNode.textContent));
      } catch (_) { /* Safe defaults keep the catalogue usable if a label is malformed. */ }

      this.querySelectorAll('[data-select-design], [data-select-family]').forEach(button => { button.disabled = true; });
      this.controls = {
        family: this.querySelector('select[data-family]'),
        design: this.querySelector('select[data-design]'),
        search: this.querySelector('[data-search]'),
        stock: this.querySelector('[data-stock]'),
        sort: this.querySelector('[data-sort]')
      };

      try {
        if (!this.records) {
          this.setLoading(true);
          const cards = await this.loadAllCards(signal);
          if (signal.aborted) return;
          this.records = cards.map((element, index) => {
            const design = element.dataset.design || '';
            return {
              element,
              index,
              design,
              family: element.dataset.family || 'other',
              familyLabel: element.dataset.familyLabel || element.dataset.family || '',
              designKey: element.dataset.designKey || design,
              title: element.dataset.title || '',
              variantText: element.dataset.variantSearch || '',
              price: Number(element.dataset.price) || 0,
              available: element.dataset.available === 'true'
            };
          });
          const priorities = ['belt','tape','rope','sweat','bottle','weightliftingwrap','straps','wristwrap','sunglasses','roller','timer','collars','nasal','other'];
          const rounds = new Map();
          this.records.forEach(record => {
            const key = `${record.available}:${record.family}`;
            const round = rounds.get(key) || 0;
            rounds.set(key, round + 1);
            const priority = priorities.indexOf(record.family);
            record.featuredRank = round * priorities.length + (priority < 0 ? priorities.length : priority);
          });
          this.designKeys = new Set(this.records.map(record => record.designKey));
          this.familyKeys = new Set(this.records.map(record => record.family));
          this.updateCatalogInfo();
        }

        if (signal.aborted) return;
        this.state = this.readURL();
        this.limit = 12;
        this.updateOptions();
        this.syncControls();
        this.bindEvents(signal);
        this.render();
        this.setLoading(false);
        this.querySelectorAll('[data-tools]').forEach(node => { node.hidden = false; });
        this.querySelectorAll('[data-server-pagination], [data-load-error]').forEach(node => { node.hidden = true; });
        this.querySelectorAll('[data-select-design], [data-select-family]').forEach(button => { button.disabled = false; });
        this.dataset.ready = 'true';
      } catch (error) {
        if (signal.aborted) return;
        this.setLoading(false);
        this.querySelectorAll('[data-tools]').forEach(node => { node.hidden = true; });
        this.querySelectorAll('[data-server-pagination]').forEach(node => { node.hidden = false; });
        const errorNode = this.querySelector('[data-load-error]');
        if (errorNode) {
          errorNode.hidden = false;
          const message = errorNode.querySelector('[data-error-message]');
          if (message) message.textContent = this.labels.loadError;
          else if (!errorNode.textContent.trim()) errorNode.textContent = this.labels.loadError;
        }
        this.querySelectorAll('[data-show-more]').forEach(node => { node.hidden = true; });
        Array.from(this.grid.querySelectorAll('[data-product-card]')).forEach(card => { card.hidden = false; });
        delete this.dataset.ready;
      }
    }

    setLoading(loading) {
      this.setAttribute('aria-busy', loading ? 'true' : 'false');
      const status = this.querySelector('[data-load-status]');
      if (status) {
        status.hidden = !loading;
        status.textContent = loading ? this.labels.loading : '';
      }
    }

    async loadAllCards(signal) {
      const initial = Array.from(this.grid.querySelectorAll('[data-product-card]'));
      const pages = Math.max(1, Number.parseInt(this.dataset.pages, 10) || 1);
      const currentPage = Math.max(1, Number.parseInt(this.dataset.page, 10) || 1);
      const expected = Number.parseInt(this.dataset.total, 10);
      const pageCards = new Map([[currentPage, initial]]);

      for (let page = 1; page <= pages; page += 1) {
        if (page === currentPage) continue;
        const url = new URL(window.location.href);
        url.searchParams.set('section_id', this.dataset.sectionId || this.id);
        url.searchParams.set(this.dataset.pageParam || 'page', String(page));
        const response = await fetch(url.toString(), {
          signal,
          credentials: 'same-origin',
          headers: { Accept: 'text/html' }
        });
        if (!response.ok) throw new Error('Could not load a catalogue page.');
        const html = await response.text();
        if (signal.aborted) throw new DOMException('Aborted', 'AbortError');
        const document = new DOMParser().parseFromString(html, 'text/html');
        const sections = Array.from(document.querySelectorAll('elitex-material-collection'));
        const section = sections.find(node => node.dataset.sectionId === this.dataset.sectionId);
        const grid = section && section.querySelector('[data-product-grid]');
        if (!grid) throw new Error('The catalogue page was incomplete.');
        const cards = Array.from(grid.querySelectorAll('[data-product-card]'));
        if (!cards.length) throw new Error('A catalogue page contained no products.');
        pageCards.set(page, cards);
      }

      const cards = Array.from(pageCards.entries()).sort((a, b) => a[0] - b[0]).flatMap(entry => entry[1]);
      const identifiers = cards.map(card => card.dataset.id).filter(Boolean);
      if (new Set(identifiers).size !== identifiers.length) throw new Error('A catalogue page was repeated.');
      if (Number.isFinite(expected) && cards.length !== expected) throw new Error('The catalogue count changed during loading.');

      // Commit only after every page succeeds; a failure preserves the original server page.
      if (pages > 1) {
        const fragment = window.document.createDocumentFragment();
        cards.forEach(card => { fragment.appendChild(card); });
        this.grid.appendChild(fragment);
      }
      return cards;
    }

    updateCatalogInfo() {
      const available = this.records.filter(record => record.available);
      const pool = available.length ? available : this.records;
      const cheapest = pool.reduce((best, record) => !best || record.price < best.price ? record : best, null);
      const money = cheapest && cheapest.element.querySelector('[data-card-money]');
      this.querySelectorAll('[data-catalog-from]').forEach(node => {
        if (money) node.textContent = money.textContent.trim();
        else node.hidden = true;
      });
      this.querySelectorAll('[data-select-design]').forEach(button => {
        button.hidden = !this.designKeys.has(button.dataset.selectDesign);
      });
      this.querySelectorAll('[data-select-family]').forEach(button => {
        button.hidden = Boolean(button.dataset.selectFamily) && !this.familyKeys.has(button.dataset.selectFamily);
      });
    }

    defaults() {
      return { family: '', design: '', search: '', stock: false, sort: 'featured' };
    }

    readURL() {
      const params = new URL(window.location.href).searchParams;
      const state = this.defaults();
      state.family = params.get('emat_family') || '';
      state.design = params.get('emat_use') || '';
      state.search = params.get('emat_search') || '';
      state.stock = params.get('emat_stock') === '1';
      const sort = params.get('emat_sort');
      state.sort = ['featured', 'price-asc', 'price-desc', 'name'].includes(sort) ? sort : 'featured';
      return state;
    }

    writeURL() {
      const url = new URL(window.location.href);
      const values = {
        emat_family: this.state.family,
        emat_use: this.state.design,
        emat_search: this.state.search,
        emat_stock: this.state.stock ? '1' : '',
        emat_sort: this.state.sort === 'featured' ? '' : this.state.sort
      };
      Object.entries(values).forEach(([key, value]) => {
        if (value) url.searchParams.set(key, value);
        else url.searchParams.delete(key);
      });
      try { window.history.replaceState(window.history.state, '', url.toString()); }
      catch (_) { /* Preview sandboxes may disallow history updates. */ }
    }

    updateOptions() {
      const families = new Map();
      this.records.forEach(record => {
        if (record.family && !families.has(record.family)) families.set(record.family, record.familyLabel || record.family);
      });
      const familyOptions = Array.from(families).sort((a, b) => a[1].localeCompare(b[1], undefined, { sensitivity: 'base' }));
      this.setOptions(this.controls.family, this.labels.allFamilies, familyOptions);
      if (this.state.family && !families.has(this.state.family)) this.state.family = '';
      const designs = new Map();
      this.records.forEach(record => {
        if (record.designKey && !designs.has(record.designKey)) designs.set(record.designKey, record.design || record.designKey);
      });
      const designOptions = Array.from(designs).sort((a, b) => a[1].localeCompare(b[1], undefined, { sensitivity: 'base' }));
      this.setOptions(this.controls.design, this.labels.allDesigns, designOptions);
      if (this.state.design && !designs.has(this.state.design)) this.state.design = '';
    }

    setOptions(select, placeholder, values) {
      if (!select) return;
      const fragment = document.createDocumentFragment();
      [['', placeholder], ...values].forEach(([value, label]) => {
        const option = document.createElement('option');
        option.value = value;
        option.textContent = label;
        fragment.appendChild(option);
      });
      select.replaceChildren(fragment);
    }

    syncControls() {
      Object.entries(this.controls).forEach(([name, control]) => {
        if (!control) return;
        if (name === 'stock') control.checked = this.state.stock;
        else control.value = this.state[name];
      });
    }

    bindEvents(signal) {
      this.addEventListener('click', event => {
        const target = event.target instanceof Element ? event.target : null;
        if (!target) return;
        const family = target.closest('[data-select-family]');
        if (family && this.contains(family)) {
          event.preventDefault();
          const key = family.dataset.selectFamily;
          if (key && !this.familyKeys.has(key)) return;
          this.state.family = this.state.family === key ? '' : key;
          this.syncControls();
          this.change();
          return;
        }
        const design = target.closest('[data-select-design]');
        if (design && this.contains(design)) {
          event.preventDefault();
          const key = design.dataset.selectDesign;
          if (!this.designKeys.has(key)) return;
          this.state.design = this.state.design === key ? '' : key;
          this.syncControls();
          this.change();
          return;
        }
        if (target.closest('[data-reset]')) {
          event.preventDefault();
          this.state = this.defaults();
          this.updateOptions();
          this.syncControls();
          this.change();
          return;
        }
        if (target.closest('[data-show-more]')) {
          event.preventDefault();
          this.limit += 12;
          this.render();
        }
      }, { signal });

      Object.entries(this.controls).forEach(([name, control]) => {
        if (!control) return;
        control.addEventListener(name === 'search' ? 'input' : 'change', () => {
          this.state[name] = name === 'stock' ? control.checked : control.value;
          this.change();
        }, { signal });
      });

      window.addEventListener('popstate', () => {
        this.state = this.readURL();
        this.limit = 12;
        this.updateOptions();
        this.syncControls();
        this.render();
      }, { signal });
    }

    change() {
      this.limit = 12;
      this.render();
      this.writeURL();
    }

    normalize(value) {
      return String(value).normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase().trim();
    }

    format(template, values) {
      return String(template).replace(/\{(\w+)\}/g, (match, key) => Object.hasOwn(values, key) ? String(values[key]) : match);
    }

    render() {
      const state = this.state;
      const terms = this.normalize(state.search).split(/\s+/).filter(Boolean);
      const matches = this.records.filter(record => {
        if (state.family && record.family !== state.family) return false;
        if (state.design && record.designKey !== state.design) return false;
        if (state.stock && !record.available) return false;
        if (terms.length) {
          const text = this.normalize(`${record.title} ${record.variantText} ${record.familyLabel} ${record.design} ${record.designKey}`);
          if (!terms.every(term => text.includes(term))) return false;
        }
        return true;
      });
      matches.sort((a, b) => {
        if (state.sort === 'price-asc') return a.price - b.price || a.index - b.index;
        if (state.sort === 'price-desc') return b.price - a.price || a.index - b.index;
        if (state.sort === 'name') return a.title.localeCompare(b.title, undefined, { sensitivity: 'base', numeric: true }) || a.index - b.index;
        return Number(b.available) - Number(a.available) || a.featuredRank - b.featuredRank || a.index - b.index;
      });

      const visible = new Set(matches.slice(0, this.limit));
      const matchSet = new Set(matches);
      const fragment = document.createDocumentFragment();
      [...matches, ...this.records.filter(record => !matchSet.has(record))].forEach(record => {
        record.element.hidden = !visible.has(record);
        fragment.appendChild(record.element);
      });
      this.grid.appendChild(fragment);

      const count = this.querySelector('[data-result-count]');
      if (count) count.textContent = this.format(matches.length === 1 ? this.labels.countOne : this.labels.count, { count: matches.length });
      const progress = this.querySelector('[data-progress]');
      if (progress) progress.textContent = this.format(this.labels.shown, { shown: visible.size, total: matches.length });
      const more = this.querySelector('[data-show-more]');
      if (more) more.hidden = visible.size >= matches.length;
      const empty = this.querySelector('[data-empty]');
      if (empty) {
        empty.hidden = matches.length !== 0;
        const message = empty.querySelector('[data-empty-message]');
        if (message) message.textContent = this.labels.noResults;
      }

      this.querySelectorAll('[data-select-family]').forEach(button => {
        const selected = button.dataset.selectFamily === state.family;
        button.setAttribute('aria-pressed', selected ? 'true' : 'false');
        button.classList.toggle('is-active', selected);
      });
      this.querySelectorAll('[data-select-design]').forEach(button => {
        const selected = button.dataset.selectDesign === state.design;
        button.setAttribute('aria-pressed', selected ? 'true' : 'false');
        button.classList.toggle('is-active', selected);
      });
    }
  }

  customElements.define('elitex-material-collection', ElitexMaterialCollection);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elitex-mochila-comida"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('elitex-food-story')) {
  customElements.define('elitex-food-story', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.addEventListener('click', event => {
        const link = event.target.closest('[data-meal-purchase]');
        if (!link || !this.contains(link) || this.dataset.productContext !== 'true') return;
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
        const variantIds = new Set((this.dataset.variantIds || '').trim().split(/\s+/));
        const nativeForm = Array.from(document.querySelectorAll('form[action*="/cart/add"]')).find(form => {
          const field = form.querySelector('[name="id"]');
          return field && variantIds.has(String(field.value)) && form.getClientRects().length > 0 && !this.contains(form);
        });
        if (!nativeForm) return;
        const control = Array.from(nativeForm.querySelectorAll('button[type="submit"], input[type="submit"], select, input:not([type="hidden"]):not([type="radio"]):not([type="checkbox"]), button')).find(item => !item.disabled && item.getClientRects().length > 0);
        event.preventDefault();
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        nativeForm.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'center' });
        if (control) control.focus({ preventScroll: true });
      }, { signal: this.controller.signal });
      this.addEventListener('shopify:block:select', event => {
        const detail = event.target.closest('details.exmeal-question');
        if (detail && this.contains(detail)) detail.open = true;
      }, { signal: this.controller.signal });
    }
    disconnectedCallback() {
      if (this.controller) this.controller.abort();
      this.controller = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elitex-mochilas-coleccion"] && !Shopify.designMode) return;
  try {
    
/* Elitex backpack collection. Prices, availability and images remain server-rendered. */
(() => {
  'use strict';

  if (!window.customElements || customElements.get('elitex-backpack-collection')) return;

  class ElitexBackpackCollection extends HTMLElement {
    connectedCallback() {
      if (this.connectionController && !this.connectionController.signal.aborted) return;
      this.connectionController = new AbortController();
      const signal = this.connectionController.signal;
      this.connect(signal);
    }

    disconnectedCallback() {
      if (this.connectionController) this.connectionController.abort();
    }

    async connect(signal) {
      this.grid = this.querySelector('[data-product-grid]');
      if (!this.grid) return;

      this.labels = {
        allName: 'Todas las mochilas',
        allDescription: 'Encuentra tu modelo y elige tu diseño.',
        count: '{count} diseños',
        countOne: '{count} diseño',
        from: 'Desde',
        loading: 'Preparando todos los diseños…',
        loadError: 'No hemos podido preparar los filtros. Puedes explorar los productos a continuación.',
        noResults: 'No hay diseños con estos filtros.',
        shown: '{shown} de {total} diseños',
        loadMore: 'Ver más diseños',
        allCapacities: 'Todas las capacidades',
        allDesigns: 'Todos los diseños'
      };
      const labelsNode = this.querySelector('[data-ui-labels]');
      try {
        if (labelsNode) Object.assign(this.labels, JSON.parse(labelsNode.textContent));
      } catch (_) { /* Safe defaults keep the catalogue usable if a label is malformed. */ }

      this.controls = {
        capacity: this.querySelector('[data-capacity]'),
        design: this.querySelector('[data-design]'),
        search: this.querySelector('[data-search]'),
        stock: this.querySelector('[data-stock]'),
        sort: this.querySelector('[data-sort]')
      };

      try {
        if (!this.records) {
          this.setLoading(true);
          const cards = await this.loadAllCards(signal);
          if (signal.aborted) return;
          this.records = cards.map((element, index) => {
            const design = element.dataset.design || '';
            return {
              element,
              index,
              family: element.dataset.family || 'other',
              capacity: element.dataset.capacity || '',
              design,
              designKey: element.dataset.designKey || design,
              title: element.dataset.title || '',
              price: Number(element.dataset.price) || 0,
              available: element.dataset.available === 'true'
            };
          });
          this.families = new Set(this.records.map(record => record.family));
          this.updateFamilies();
        }

        if (signal.aborted) return;
        this.state = this.readURL();
        this.limit = 24;
        this.updateOptions();
        this.syncControls();
        this.bindEvents(signal);
        this.render();
        this.setLoading(false);
        this.querySelectorAll('[data-tools], [data-family-panel]').forEach(node => { node.hidden = false; });
        this.querySelectorAll('[data-server-pagination], [data-load-error]').forEach(node => { node.hidden = true; });
        this.dataset.ready = 'true';
      } catch (error) {
        if (signal.aborted) return;
        this.setLoading(false);
        this.querySelectorAll('[data-tools], [data-family-panel]').forEach(node => { node.hidden = true; });
        this.querySelectorAll('[data-server-pagination]').forEach(node => { node.hidden = false; });
        const errorNode = this.querySelector('[data-load-error]');
        if (errorNode) {
          errorNode.hidden = false;
          const message = errorNode.querySelector('[data-error-message]');
          if (message) message.textContent = this.labels.loadError;
          else if (!errorNode.textContent.trim()) errorNode.textContent = this.labels.loadError;
        }
        this.querySelectorAll('[data-show-more]').forEach(node => { node.hidden = true; });
        Array.from(this.grid.querySelectorAll('[data-product-card]')).forEach(card => { card.hidden = false; });
        delete this.dataset.ready;
      }
    }

    setLoading(loading) {
      this.setAttribute('aria-busy', loading ? 'true' : 'false');
      const status = this.querySelector('[data-load-status]');
      if (status) {
        status.hidden = !loading;
        status.textContent = loading ? this.labels.loading : '';
      }
    }

    async loadAllCards(signal) {
      const initial = Array.from(this.grid.querySelectorAll('[data-product-card]'));
      const pages = Math.max(1, Number.parseInt(this.dataset.pages, 10) || 1);
      const currentPage = Math.max(1, Number.parseInt(this.dataset.page, 10) || 1);
      const expected = Number.parseInt(this.dataset.total, 10);
      const pageCards = new Map([[currentPage, initial]]);

      for (let page = 1; page <= pages; page += 1) {
        if (page === currentPage) continue;
        const url = new URL(window.location.href);
        url.searchParams.set('section_id', this.dataset.sectionId || this.id);
        url.searchParams.set(this.dataset.pageParam || 'page', String(page));
        const response = await fetch(url.toString(), {
          signal,
          credentials: 'same-origin',
          headers: { Accept: 'text/html' }
        });
        if (!response.ok) throw new Error('Could not load a catalogue page.');
        const html = await response.text();
        if (signal.aborted) throw new DOMException('Aborted', 'AbortError');
        const document = new DOMParser().parseFromString(html, 'text/html');
        const sections = Array.from(document.querySelectorAll('elitex-backpack-collection'));
        const section = sections.find(node => node.dataset.sectionId === this.dataset.sectionId);
        const grid = section && section.querySelector('[data-product-grid]');
        if (!grid) throw new Error('The catalogue page was incomplete.');
        const cards = Array.from(grid.querySelectorAll('[data-product-card]'));
        if (!cards.length) throw new Error('A catalogue page contained no products.');
        pageCards.set(page, cards);
      }

      const cards = Array.from(pageCards.entries()).sort((a, b) => a[0] - b[0]).flatMap(entry => entry[1]);
      const identifiers = cards.map(card => card.dataset.id).filter(Boolean);
      if (new Set(identifiers).size !== identifiers.length) throw new Error('A catalogue page was repeated.');
      if (Number.isFinite(expected) && cards.length !== expected) throw new Error('The catalogue count changed during loading.');

      // Commit only after every page succeeds; a failure preserves the original server page.
      if (pages > 1) {
        const fragment = window.document.createDocumentFragment();
        cards.forEach(card => { fragment.appendChild(card); });
        this.grid.appendChild(fragment);
      }
      return cards;
    }

    updateFamilies() {
      this.querySelectorAll('[data-family-link]').forEach(link => {
        const records = this.records.filter(record => record.family === link.dataset.family);
        link.hidden = records.length === 0;
        if (!records.length) return;
        const count = link.querySelector('[data-family-count]');
        if (count) count.textContent = this.format(records.length === 1 ? this.labels.countOne : this.labels.count, { count: records.length });

        const available = records.filter(record => record.available);
        const pool = available.length ? available : records;
        const cheapest = pool.reduce((best, record) => record.price < best.price ? record : best, pool[0]);
        const money = cheapest.element.querySelector('[data-card-money]');
        const from = link.querySelector('[data-family-from]');
        if (from && money) from.textContent = `${this.labels.from} ${money.textContent.trim()}`;

        const image = link.querySelector('[data-family-image]');
        if (image && link.dataset.customImage !== 'true') {
          const preferred = pool.find(record => record.element.dataset.id === link.dataset.referenceId);
          const sourceCard = (preferred || pool[0]).element;
          const sourceImage = sourceCard.querySelector('[data-card-image]') || sourceCard.querySelector('img');
          if (sourceImage) {
            const customSource = sourceCard.dataset.familyImageSource;
            ['src', 'srcset', 'sizes'].forEach(attribute => {
              const value = customSource ? (attribute === 'src' ? customSource : '') : sourceImage.getAttribute(attribute);
              if (value) image.setAttribute(attribute, value);
              else image.removeAttribute(attribute);
            });
            image.alt = sourceImage.alt;
          }
        }
      });
    }

    defaults() {
      return { family: '', capacity: '', design: '', search: '', stock: false, sort: 'featured' };
    }

    readURL() {
      const params = new URL(window.location.href).searchParams;
      const state = this.defaults();
      const family = params.get('ex_family') || '';
      state.family = this.families.has(family) ? family : '';
      state.capacity = params.get('ex_capacity') || '';
      state.design = params.get('ex_design') || '';
      state.search = params.get('ex_search') || '';
      state.stock = params.get('ex_stock') === '1';
      const sort = params.get('ex_sort');
      state.sort = ['featured', 'price-asc', 'price-desc', 'name'].includes(sort) ? sort : 'featured';
      return state;
    }

    writeURL() {
      const url = new URL(window.location.href);
      const values = {
        ex_family: this.state.family,
        ex_capacity: this.state.capacity,
        ex_design: this.state.design,
        ex_search: this.state.search,
        ex_stock: this.state.stock ? '1' : '',
        ex_sort: this.state.sort === 'featured' ? '' : this.state.sort
      };
      Object.entries(values).forEach(([key, value]) => {
        if (value) url.searchParams.set(key, value);
        else url.searchParams.delete(key);
      });
      try { window.history.replaceState(window.history.state, '', url.toString()); }
      catch (_) { /* Preview sandboxes may disallow history updates. */ }
    }

    updateOptions() {
      const records = this.records.filter(record => !this.state.family || record.family === this.state.family);
      const capacities = Array.from(new Set(records.map(record => record.capacity).filter(Boolean)))
        .sort((a, b) => a.localeCompare(b, undefined, { numeric: true }));
      const designs = new Map();
      records.forEach(record => {
        if (record.designKey && !designs.has(record.designKey)) designs.set(record.designKey, record.design || record.designKey);
      });
      const designOptions = Array.from(designs).sort((a, b) => a[1].localeCompare(b[1], undefined, { sensitivity: 'base' }));
      this.setOptions(this.controls.capacity, this.labels.allCapacities, capacities.map(value => [value, `${value} L`]));
      this.setOptions(this.controls.design, this.labels.allDesigns, designOptions);
      if (this.state.capacity && !capacities.includes(this.state.capacity)) this.state.capacity = '';
      if (this.state.design && !designs.has(this.state.design)) this.state.design = '';
    }

    setOptions(select, placeholder, values) {
      if (!select) return;
      const fragment = document.createDocumentFragment();
      [['', placeholder], ...values].forEach(([value, label]) => {
        const option = document.createElement('option');
        option.value = value;
        option.textContent = label;
        fragment.appendChild(option);
      });
      select.replaceChildren(fragment);
    }

    syncControls() {
      Object.entries(this.controls).forEach(([name, control]) => {
        if (!control) return;
        if (name === 'stock') control.checked = this.state.stock;
        else control.value = this.state[name];
      });
    }

    bindEvents(signal) {
      this.addEventListener('click', event => {
        const target = event.target instanceof Element ? event.target : null;
        if (!target) return;
        const family = target.closest('[data-family-link], [data-family-all]');
        if (family && this.contains(family)) {
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          this.state.family = family.hasAttribute('data-family-all') ? '' : family.dataset.family || '';
          this.state.capacity = '';
          this.state.design = '';
          this.updateOptions();
          this.syncControls();
          this.change();
          const catalog = this.querySelector('[data-catalog]');
          if (catalog) catalog.scrollIntoView({
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
            block: 'start'
          });
          return;
        }
        if (target.closest('[data-reset]')) {
          event.preventDefault();
          this.state = this.defaults();
          this.updateOptions();
          this.syncControls();
          this.change();
          return;
        }
        if (target.closest('[data-show-more]')) {
          event.preventDefault();
          this.limit += 24;
          this.render();
        }
      }, { signal });

      this.addEventListener('keydown', event => {
        if (event.key === ' ' && event.target instanceof Element && event.target.matches('a[data-family-link][role="button"]')) {
          event.preventDefault();
          event.target.click();
        }
      }, { signal });

      Object.entries(this.controls).forEach(([name, control]) => {
        if (!control) return;
        control.addEventListener(name === 'search' ? 'input' : 'change', () => {
          this.state[name] = name === 'stock' ? control.checked : control.value;
          this.change();
        }, { signal });
      });

      window.addEventListener('popstate', () => {
        this.state = this.readURL();
        this.limit = 24;
        this.updateOptions();
        this.syncControls();
        this.render();
      }, { signal });
    }

    change() {
      this.limit = 24;
      this.render();
      this.writeURL();
    }

    normalize(value) {
      return String(value).normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase().trim();
    }

    format(template, values) {
      return String(template).replace(/\{(\w+)\}/g, (match, key) => Object.hasOwn(values, key) ? String(values[key]) : match);
    }

    render() {
      const state = this.state;
      const terms = this.normalize(state.search).split(/\s+/).filter(Boolean);
      const matches = this.records.filter(record => {
        if (state.family && record.family !== state.family) return false;
        if (state.capacity && record.capacity !== state.capacity) return false;
        if (state.design && record.designKey !== state.design) return false;
        if (state.stock && !record.available) return false;
        if (terms.length) {
          const text = this.normalize(`${record.title} ${record.design} ${record.designKey} ${record.capacity}`);
          if (!terms.every(term => text.includes(term))) return false;
        }
        return true;
      });
      matches.sort((a, b) => {
        if (state.sort === 'price-asc') return a.price - b.price || a.index - b.index;
        if (state.sort === 'price-desc') return b.price - a.price || a.index - b.index;
        if (state.sort === 'name') return a.title.localeCompare(b.title, undefined, { sensitivity: 'base', numeric: true }) || a.index - b.index;
        return Number(b.available) - Number(a.available) || a.index - b.index;
      });

      const visible = new Set(matches.slice(0, this.limit));
      const matchSet = new Set(matches);
      const fragment = document.createDocumentFragment();
      [...matches, ...this.records.filter(record => !matchSet.has(record))].forEach(record => {
        record.element.hidden = !visible.has(record);
        fragment.appendChild(record.element);
      });
      this.grid.appendChild(fragment);

      const count = this.querySelector('[data-result-count]');
      if (count) count.textContent = this.format(matches.length === 1 ? this.labels.countOne : this.labels.count, { count: matches.length });
      const progress = this.querySelector('[data-progress]');
      if (progress) progress.textContent = this.format(this.labels.shown, { shown: visible.size, total: matches.length });
      const more = this.querySelector('[data-show-more]');
      if (more) more.hidden = visible.size >= matches.length;
      const empty = this.querySelector('[data-empty]');
      if (empty) {
        empty.hidden = matches.length !== 0;
        const message = empty.querySelector('[data-empty-message]');
        if (message) message.textContent = this.labels.noResults;
      }

      const familyLinks = Array.from(this.querySelectorAll('[data-family-link]'));
      familyLinks.forEach(link => {
        const selected = link.dataset.family === state.family;
        link.setAttribute('aria-pressed', selected ? 'true' : 'false');
        link.classList.toggle('is-active', selected);
      });
      this.querySelectorAll('[data-family-all]').forEach(button => {
        button.setAttribute('aria-pressed', state.family ? 'false' : 'true');
        button.classList.toggle('is-active', !state.family);
      });
      const selected = familyLinks.find(link => link.dataset.family === state.family && link.dataset.name);
      const activeName = this.querySelector('[data-active-name]');
      if (activeName) activeName.textContent = selected ? selected.dataset.name : this.labels.allName;
      const description = this.querySelector('[data-active-description]');
      if (description) description.textContent = selected ? selected.dataset.description || '' : this.labels.allDescription;
    }
  }

  customElements.define('elitex-backpack-collection', ElitexBackpackCollection);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elitex-munequeras-tela"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('elitex-cloth-story')) {
  customElements.define('elitex-cloth-story', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.addEventListener('click', event => {
        const target = event.target instanceof Element ? event.target : null;
        const link = target && target.closest('[data-cw-purchase]');
        if (!link || !this.contains(link) || this.dataset.productContext !== 'true') return;
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
        const variantIds = new Set((this.dataset.variantIds || '').trim().split(/\s+/));
        const nativeForm = Array.from(document.querySelectorAll('form[action*="/cart/add"]')).find(form => {
          const field = form.querySelector('[name="id"]');
          return field && variantIds.has(String(field.value)) && form.getClientRects().length > 0 && !this.contains(form);
        });
        if (!nativeForm) return;
        const control = Array.from(nativeForm.querySelectorAll('button[type="submit"], input[type="submit"], select, input:not([type="hidden"]):not([type="radio"]):not([type="checkbox"]), button')).find(item => !item.disabled && item.getClientRects().length > 0);
        event.preventDefault();
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        nativeForm.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'center' });
        if (control) control.focus({ preventScroll: true });
      }, { signal: this.controller.signal });
      this.addEventListener('shopify:block:select', event => {
        const detail = event.target.closest('details.excw-question');
        if (detail && this.contains(detail)) detail.open = true;
      }, { signal: this.controller.signal });
    }
    disconnectedCallback() {
      if (this.controller) this.controller.abort();
      this.controller = null;
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elitex-parches-coleccion"] && !Shopify.designMode) return;
  try {
    
/* Elitex patches collection. Prices, availability and images remain server-rendered. */
(() => {
  'use strict';

  if (!window.customElements || customElements.get('elitex-patches-collection')) return;

  class ElitexPatchesCollection extends HTMLElement {
    connectedCallback() {
      if (this.connectionController && !this.connectionController.signal.aborted) return;
      this.connectionController = new AbortController();
      const signal = this.connectionController.signal;
      this.connect(signal);
    }

    disconnectedCallback() {
      if (this.connectionController) this.connectionController.abort();
    }

    async connect(signal) {
      this.grid = this.querySelector('[data-product-grid]');
      if (!this.grid) return;

      this.labels = {
        count: '{count} productos',
        countOne: '{count} producto',
        loading: 'Preparando el catálogo…',
        loadError: 'No hemos podido preparar los filtros. Puedes explorar los productos a continuación.',
        noResults: 'No hay productos con estos filtros.',
        shown: '{shown} de {total} productos',
        loadMore: 'Ver más productos',
        allDesigns: 'Todos los diseños',
        allFamilies: 'Todos los modelos'
      };
      const labelsNode = this.querySelector('[data-ui-labels]');
      try {
        if (labelsNode) Object.assign(this.labels, JSON.parse(labelsNode.textContent));
      } catch (_) { /* Safe defaults keep the catalogue usable if a label is malformed. */ }

      this.querySelectorAll('[data-select-design], [data-select-family]').forEach(button => { button.disabled = true; });
      this.controls = {
        family: this.querySelector('select[data-family]'),
        design: this.querySelector('select[data-design]'),
        search: this.querySelector('[data-search]'),
        stock: this.querySelector('[data-stock]'),
        sort: this.querySelector('[data-sort]')
      };

      try {
        if (!this.records) {
          this.setLoading(true);
          const cards = await this.loadAllCards(signal);
          if (signal.aborted) return;
          this.records = cards.map((element, index) => {
            const design = element.dataset.design || '';
            return {
              element,
              index,
              design,
              family: element.dataset.family || 'other',
              familyLabel: element.dataset.familyLabel || element.dataset.family || '',
              designKey: element.dataset.designKey || design,
              title: element.dataset.title || '',
              variantText: element.dataset.variantSearch || '',
              price: Number(element.dataset.price) || 0,
              available: element.dataset.available === 'true'
            };
          });
          this.designKeys = new Set(this.records.map(record => record.designKey));
          this.familyKeys = new Set(this.records.map(record => record.family));
          this.updateCatalogInfo();
        }

        if (signal.aborted) return;
        this.state = this.readURL();
        this.limit = 12;
        this.updateOptions();
        this.syncControls();
        this.bindEvents(signal);
        this.render();
        this.setLoading(false);
        this.querySelectorAll('[data-tools]').forEach(node => { node.hidden = false; });
        this.querySelectorAll('[data-server-pagination], [data-load-error]').forEach(node => { node.hidden = true; });
        this.querySelectorAll('[data-select-design], [data-select-family]').forEach(button => { button.disabled = false; });
        this.dataset.ready = 'true';
      } catch (error) {
        if (signal.aborted) return;
        this.setLoading(false);
        this.querySelectorAll('[data-tools]').forEach(node => { node.hidden = true; });
        this.querySelectorAll('[data-server-pagination]').forEach(node => { node.hidden = false; });
        const errorNode = this.querySelector('[data-load-error]');
        if (errorNode) {
          errorNode.hidden = false;
          const message = errorNode.querySelector('[data-error-message]');
          if (message) message.textContent = this.labels.loadError;
          else if (!errorNode.textContent.trim()) errorNode.textContent = this.labels.loadError;
        }
        this.querySelectorAll('[data-show-more]').forEach(node => { node.hidden = true; });
        Array.from(this.grid.querySelectorAll('[data-product-card]')).forEach(card => { card.hidden = false; });
        delete this.dataset.ready;
      }
    }

    setLoading(loading) {
      this.setAttribute('aria-busy', loading ? 'true' : 'false');
      const status = this.querySelector('[data-load-status]');
      if (status) {
        status.hidden = !loading;
        status.textContent = loading ? this.labels.loading : '';
      }
    }

    async loadAllCards(signal) {
      const initial = Array.from(this.grid.querySelectorAll('[data-product-card]'));
      const pages = Math.max(1, Number.parseInt(this.dataset.pages, 10) || 1);
      const currentPage = Math.max(1, Number.parseInt(this.dataset.page, 10) || 1);
      const expected = Number.parseInt(this.dataset.total, 10);
      const pageCards = new Map([[currentPage, initial]]);

      for (let page = 1; page <= pages; page += 1) {
        if (page === currentPage) continue;
        const url = new URL(window.location.href);
        url.searchParams.set('section_id', this.dataset.sectionId || this.id);
        url.searchParams.set(this.dataset.pageParam || 'page', String(page));
        const response = await fetch(url.toString(), {
          signal,
          credentials: 'same-origin',
          headers: { Accept: 'text/html' }
        });
        if (!response.ok) throw new Error('Could not load a catalogue page.');
        const html = await response.text();
        if (signal.aborted) throw new DOMException('Aborted', 'AbortError');
        const document = new DOMParser().parseFromString(html, 'text/html');
        const sections = Array.from(document.querySelectorAll('elitex-patches-collection'));
        const section = sections.find(node => node.dataset.sectionId === this.dataset.sectionId);
        const grid = section && section.querySelector('[data-product-grid]');
        if (!grid) throw new Error('The catalogue page was incomplete.');
        const cards = Array.from(grid.querySelectorAll('[data-product-card]'));
        if (!cards.length) throw new Error('A catalogue page contained no products.');
        pageCards.set(page, cards);
      }

      const cards = Array.from(pageCards.entries()).sort((a, b) => a[0] - b[0]).flatMap(entry => entry[1]);
      const identifiers = cards.map(card => card.dataset.id).filter(Boolean);
      if (new Set(identifiers).size !== identifiers.length) throw new Error('A catalogue page was repeated.');
      if (Number.isFinite(expected) && cards.length !== expected) throw new Error('The catalogue count changed during loading.');

      // Commit only after every page succeeds; a failure preserves the original server page.
      if (pages > 1) {
        const fragment = window.document.createDocumentFragment();
        cards.forEach(card => { fragment.appendChild(card); });
        this.grid.appendChild(fragment);
      }
      return cards;
    }

    updateCatalogInfo() {
      const available = this.records.filter(record => record.available);
      const pool = available.length ? available : this.records;
      const cheapest = pool.reduce((best, record) => !best || record.price < best.price ? record : best, null);
      const money = cheapest && cheapest.element.querySelector('[data-card-money]');
      this.querySelectorAll('[data-catalog-from]').forEach(node => {
        if (money) node.textContent = money.textContent.trim();
        else node.hidden = true;
      });
      this.querySelectorAll('[data-select-design]').forEach(button => {
        button.hidden = !this.designKeys.has(button.dataset.selectDesign);
      });
      this.querySelectorAll('[data-select-family]').forEach(button => {
        button.hidden = Boolean(button.dataset.selectFamily) && !this.familyKeys.has(button.dataset.selectFamily);
      });
    }

    defaults() {
      return { family: '', design: '', search: '', stock: false, sort: 'featured' };
    }

    readURL() {
      const params = new URL(window.location.href).searchParams;
      const state = this.defaults();
      state.family = params.get('epatch_family') || '';
      state.design = params.get('epatch_theme') || '';
      state.search = params.get('epatch_search') || '';
      state.stock = params.get('epatch_stock') === '1';
      const sort = params.get('epatch_sort');
      state.sort = ['featured', 'price-asc', 'price-desc', 'name'].includes(sort) ? sort : 'featured';
      return state;
    }

    writeURL() {
      const url = new URL(window.location.href);
      const values = {
        epatch_family: this.state.family,
        epatch_theme: this.state.design,
        epatch_search: this.state.search,
        epatch_stock: this.state.stock ? '1' : '',
        epatch_sort: this.state.sort === 'featured' ? '' : this.state.sort
      };
      Object.entries(values).forEach(([key, value]) => {
        if (value) url.searchParams.set(key, value);
        else url.searchParams.delete(key);
      });
      try { window.history.replaceState(window.history.state, '', url.toString()); }
      catch (_) { /* Preview sandboxes may disallow history updates. */ }
    }

    updateOptions() {
      const families = new Map();
      this.records.forEach(record => {
        if (record.family && !families.has(record.family)) families.set(record.family, record.familyLabel || record.family);
      });
      const familyOptions = Array.from(families).sort((a, b) => a[1].localeCompare(b[1], undefined, { sensitivity: 'base' }));
      this.setOptions(this.controls.family, this.labels.allFamilies, familyOptions);
      if (this.state.family && !families.has(this.state.family)) this.state.family = '';
      const designs = new Map();
      this.records.forEach(record => {
        if (record.designKey && !designs.has(record.designKey)) designs.set(record.designKey, record.design || record.designKey);
      });
      const designOptions = Array.from(designs).sort((a, b) => a[1].localeCompare(b[1], undefined, { sensitivity: 'base' }));
      this.setOptions(this.controls.design, this.labels.allDesigns, designOptions);
      if (this.state.design && !designs.has(this.state.design)) this.state.design = '';
    }

    setOptions(select, placeholder, values) {
      if (!select) return;
      const fragment = document.createDocumentFragment();
      [['', placeholder], ...values].forEach(([value, label]) => {
        const option = document.createElement('option');
        option.value = value;
        option.textContent = label;
        fragment.appendChild(option);
      });
      select.replaceChildren(fragment);
    }

    syncControls() {
      Object.entries(this.controls).forEach(([name, control]) => {
        if (!control) return;
        if (name === 'stock') control.checked = this.state.stock;
        else control.value = this.state[name];
      });
    }

    bindEvents(signal) {
      this.addEventListener('click', event => {
        const target = event.target instanceof Element ? event.target : null;
        if (!target) return;
        const family = target.closest('[data-select-family]');
        if (family && this.contains(family)) {
          event.preventDefault();
          const key = family.dataset.selectFamily;
          if (key && !this.familyKeys.has(key)) return;
          this.state.family = this.state.family === key ? '' : key;
          this.syncControls();
          this.change();
          return;
        }
        const design = target.closest('[data-select-design]');
        if (design && this.contains(design)) {
          event.preventDefault();
          const key = design.dataset.selectDesign;
          if (!this.designKeys.has(key)) return;
          this.state.design = this.state.design === key ? '' : key;
          this.syncControls();
          this.change();
          return;
        }
        if (target.closest('[data-reset]')) {
          event.preventDefault();
          this.state = this.defaults();
          this.updateOptions();
          this.syncControls();
          this.change();
          return;
        }
        if (target.closest('[data-show-more]')) {
          event.preventDefault();
          this.limit += 12;
          this.render();
        }
      }, { signal });

      Object.entries(this.controls).forEach(([name, control]) => {
        if (!control) return;
        control.addEventListener(name === 'search' ? 'input' : 'change', () => {
          this.state[name] = name === 'stock' ? control.checked : control.value;
          this.change();
        }, { signal });
      });

      window.addEventListener('popstate', () => {
        this.state = this.readURL();
        this.limit = 12;
        this.updateOptions();
        this.syncControls();
        this.render();
      }, { signal });
    }

    change() {
      this.limit = 12;
      this.render();
      this.writeURL();
    }

    normalize(value) {
      return String(value).normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase().trim();
    }

    format(template, values) {
      return String(template).replace(/\{(\w+)\}/g, (match, key) => Object.hasOwn(values, key) ? String(values[key]) : match);
    }

    render() {
      const state = this.state;
      const terms = this.normalize(state.search).split(/\s+/).filter(Boolean);
      const matches = this.records.filter(record => {
        if (state.family && record.family !== state.family) return false;
        if (state.design && record.designKey !== state.design) return false;
        if (state.stock && !record.available) return false;
        if (terms.length) {
          const text = this.normalize(`${record.title} ${record.variantText} ${record.familyLabel} ${record.design} ${record.designKey}`);
          if (!terms.every(term => text.includes(term))) return false;
        }
        return true;
      });
      matches.sort((a, b) => {
        if (state.sort === 'price-asc') return a.price - b.price || a.index - b.index;
        if (state.sort === 'price-desc') return b.price - a.price || a.index - b.index;
        if (state.sort === 'name') return a.title.localeCompare(b.title, undefined, { sensitivity: 'base', numeric: true }) || a.index - b.index;
        return Number(b.available) - Number(a.available) || a.index - b.index;
      });

      const visible = new Set(matches.slice(0, this.limit));
      const matchSet = new Set(matches);
      const fragment = document.createDocumentFragment();
      [...matches, ...this.records.filter(record => !matchSet.has(record))].forEach(record => {
        record.element.hidden = !visible.has(record);
        fragment.appendChild(record.element);
      });
      this.grid.appendChild(fragment);

      const count = this.querySelector('[data-result-count]');
      if (count) count.textContent = this.format(matches.length === 1 ? this.labels.countOne : this.labels.count, { count: matches.length });
      const progress = this.querySelector('[data-progress]');
      if (progress) progress.textContent = this.format(this.labels.shown, { shown: visible.size, total: matches.length });
      const more = this.querySelector('[data-show-more]');
      if (more) more.hidden = visible.size >= matches.length;
      const empty = this.querySelector('[data-empty]');
      if (empty) {
        empty.hidden = matches.length !== 0;
        const message = empty.querySelector('[data-empty-message]');
        if (message) message.textContent = this.labels.noResults;
      }

      this.querySelectorAll('[data-select-family]').forEach(button => {
        const selected = button.dataset.selectFamily === state.family;
        button.setAttribute('aria-pressed', selected ? 'true' : 'false');
        button.classList.toggle('is-active', selected);
      });
      this.querySelectorAll('[data-select-design]').forEach(button => {
        const selected = button.dataset.selectDesign === state.design;
        button.setAttribute('aria-pressed', selected ? 'true' : 'false');
        button.classList.toggle('is-active', selected);
      });
    }
  }

  customElements.define('elitex-patches-collection', ElitexPatchesCollection);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elitex-pro-45l"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('elitex-pro-story')) {
  customElements.define('elitex-pro-story', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.addEventListener('click', event => {
        const link = event.target.closest('[data-pro-purchase]');
        if (!link || !this.contains(link) || this.dataset.productContext !== 'true') return;
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
        const variantIds = new Set((this.dataset.variantIds || '').trim().split(/\s+/));
        const nativeForm = Array.from(document.querySelectorAll('form[action*="/cart/add"]')).find(form => {
          const field = form.querySelector('[name="id"]');
          return field && variantIds.has(String(field.value)) && form.getClientRects().length > 0 && !this.contains(form);
        });
        if (!nativeForm) return;
        const control = Array.from(nativeForm.querySelectorAll('button[type="submit"], input[type="submit"], select, input:not([type="hidden"]):not([type="radio"]):not([type="checkbox"]), button')).find(item => !item.disabled && item.getClientRects().length > 0);
        event.preventDefault();
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        nativeForm.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'center' });
        if (control) control.focus({ preventScroll: true });
      }, { signal: this.controller.signal });
      this.addEventListener('shopify:block:select', event => {
        const detail = event.target.closest('details.expro-question');
        if (detail && this.contains(detail)) detail.open = true;
      }, { signal: this.controller.signal });
    }
    disconnectedCallback() {
      if (this.controller) this.controller.abort();
      this.controller = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elitex-pro-series-coleccion"] && !Shopify.designMode) return;
  try {
    
/* Elitex PRO SERIES collection. Prices, availability and images remain server-rendered. */
(() => {
  'use strict';

  if (!window.customElements || customElements.get('elitex-pro-collection')) return;

  class ElitexProCollection extends HTMLElement {
    connectedCallback() {
      if (this.connectionController && !this.connectionController.signal.aborted) return;
      this.connectionController = new AbortController();
      const signal = this.connectionController.signal;
      this.connect(signal);
    }

    disconnectedCallback() {
      if (this.connectionController) this.connectionController.abort();
    }

    async connect(signal) {
      this.grid = this.querySelector('[data-product-grid]');
      if (!this.grid) return;

      this.labels = {
        count: '{count} productos',
        countOne: '{count} producto',
        loading: 'Preparando el catálogo…',
        loadError: 'No hemos podido preparar los filtros. Puedes explorar los productos a continuación.',
        noResults: 'No hay productos con estos filtros.',
        shown: '{shown} de {total} productos',
        loadMore: 'Ver más productos',
        allDesigns: 'Todos los diseños',
        allFamilies: 'Todos los modelos'
      };
      const labelsNode = this.querySelector('[data-ui-labels]');
      try {
        if (labelsNode) Object.assign(this.labels, JSON.parse(labelsNode.textContent));
      } catch (_) { /* Safe defaults keep the catalogue usable if a label is malformed. */ }

      this.querySelectorAll('[data-select-design], [data-select-family]').forEach(button => { button.disabled = true; });
      this.controls = {
        family: this.querySelector('select[data-family]'),
        design: this.querySelector('select[data-design]'),
        search: this.querySelector('[data-search]'),
        stock: this.querySelector('[data-stock]'),
        sort: this.querySelector('[data-sort]')
      };

      try {
        if (!this.records) {
          this.setLoading(true);
          const cards = await this.loadAllCards(signal);
          if (signal.aborted) return;
          this.records = cards.map((element, index) => {
            const design = element.dataset.design || '';
            return {
              element,
              index,
              design,
              family: element.dataset.family || 'other',
              familyLabel: element.dataset.familyLabel || element.dataset.family || '',
              designKey: element.dataset.designKey || design,
              title: element.dataset.title || '',
              price: Number(element.dataset.price) || 0,
              available: element.dataset.available === 'true'
            };
          });
          this.designKeys = new Set(this.records.map(record => record.designKey));
          this.familyKeys = new Set(this.records.map(record => record.family));
          this.updateCatalogInfo();
        }

        if (signal.aborted) return;
        this.state = this.readURL();
        this.limit = 12;
        this.updateOptions();
        this.syncControls();
        this.bindEvents(signal);
        this.render();
        this.setLoading(false);
        this.querySelectorAll('[data-tools]').forEach(node => { node.hidden = false; });
        this.querySelectorAll('[data-server-pagination], [data-load-error]').forEach(node => { node.hidden = true; });
        this.querySelectorAll('[data-select-design], [data-select-family]').forEach(button => { button.disabled = false; });
        this.dataset.ready = 'true';
      } catch (error) {
        if (signal.aborted) return;
        this.setLoading(false);
        this.querySelectorAll('[data-tools]').forEach(node => { node.hidden = true; });
        this.querySelectorAll('[data-server-pagination]').forEach(node => { node.hidden = false; });
        const errorNode = this.querySelector('[data-load-error]');
        if (errorNode) {
          errorNode.hidden = false;
          const message = errorNode.querySelector('[data-error-message]');
          if (message) message.textContent = this.labels.loadError;
          else if (!errorNode.textContent.trim()) errorNode.textContent = this.labels.loadError;
        }
        this.querySelectorAll('[data-show-more]').forEach(node => { node.hidden = true; });
        Array.from(this.grid.querySelectorAll('[data-product-card]')).forEach(card => { card.hidden = false; });
        delete this.dataset.ready;
      }
    }

    setLoading(loading) {
      this.setAttribute('aria-busy', loading ? 'true' : 'false');
      const status = this.querySelector('[data-load-status]');
      if (status) {
        status.hidden = !loading;
        status.textContent = loading ? this.labels.loading : '';
      }
    }

    async loadAllCards(signal) {
      const initial = Array.from(this.grid.querySelectorAll('[data-product-card]'));
      const pages = Math.max(1, Number.parseInt(this.dataset.pages, 10) || 1);
      const currentPage = Math.max(1, Number.parseInt(this.dataset.page, 10) || 1);
      const expected = Number.parseInt(this.dataset.total, 10);
      const pageCards = new Map([[currentPage, initial]]);

      for (let page = 1; page <= pages; page += 1) {
        if (page === currentPage) continue;
        const url = new URL(window.location.href);
        url.searchParams.set('section_id', this.dataset.sectionId || this.id);
        url.searchParams.set(this.dataset.pageParam || 'page', String(page));
        const response = await fetch(url.toString(), {
          signal,
          credentials: 'same-origin',
          headers: { Accept: 'text/html' }
        });
        if (!response.ok) throw new Error('Could not load a catalogue page.');
        const html = await response.text();
        if (signal.aborted) throw new DOMException('Aborted', 'AbortError');
        const document = new DOMParser().parseFromString(html, 'text/html');
        const sections = Array.from(document.querySelectorAll('elitex-pro-collection'));
        const section = sections.find(node => node.dataset.sectionId === this.dataset.sectionId);
        const grid = section && section.querySelector('[data-product-grid]');
        if (!grid) throw new Error('The catalogue page was incomplete.');
        const cards = Array.from(grid.querySelectorAll('[data-product-card]'));
        if (!cards.length) throw new Error('A catalogue page contained no products.');
        pageCards.set(page, cards);
      }

      const cards = Array.from(pageCards.entries()).sort((a, b) => a[0] - b[0]).flatMap(entry => entry[1]);
      const identifiers = cards.map(card => card.dataset.id).filter(Boolean);
      if (new Set(identifiers).size !== identifiers.length) throw new Error('A catalogue page was repeated.');
      if (Number.isFinite(expected) && cards.length !== expected) throw new Error('The catalogue count changed during loading.');

      // Commit only after every page succeeds; a failure preserves the original server page.
      if (pages > 1) {
        const fragment = window.document.createDocumentFragment();
        cards.forEach(card => { fragment.appendChild(card); });
        this.grid.appendChild(fragment);
      }
      return cards;
    }

    updateCatalogInfo() {
      this.querySelectorAll('[data-catalog-from]').forEach(node => {
        const family = node.dataset.priceFamily;
        const matching = family ? this.records.filter(record => record.family === family) : this.records;
        const available = matching.filter(record => record.available);
        const pool = available.length ? available : matching;
        const cheapest = pool.reduce((best, record) => !best || record.price < best.price ? record : best, null);
        const money = cheapest && cheapest.element.querySelector('[data-card-money]');
        node.hidden = !money;
        if (money) node.textContent = money.textContent.trim();
        const line = node.closest('[data-price-line]');
        if (line) line.hidden = !money;
      });
      this.querySelectorAll('[data-select-design]').forEach(button => {
        button.hidden = !this.designKeys.has(button.dataset.selectDesign);
      });
      this.querySelectorAll('[data-select-family]').forEach(button => {
        button.hidden = Boolean(button.dataset.selectFamily) && !this.familyKeys.has(button.dataset.selectFamily);
      });
    }

    defaults() {
      return { family: '', design: '', search: '', stock: false, sort: 'featured' };
    }

    readURL() {
      const params = new URL(window.location.href).searchParams;
      const state = this.defaults();
      state.family = params.get('epro_family') || '';
      state.design = params.get('epro_design') || '';
      state.search = params.get('epro_search') || '';
      state.stock = params.get('epro_stock') === '1';
      const sort = params.get('epro_sort');
      state.sort = ['featured', 'price-asc', 'price-desc', 'name'].includes(sort) ? sort : 'featured';
      return state;
    }

    writeURL() {
      const url = new URL(window.location.href);
      const values = {
        epro_family: this.state.family,
        epro_design: this.state.design,
        epro_search: this.state.search,
        epro_stock: this.state.stock ? '1' : '',
        epro_sort: this.state.sort === 'featured' ? '' : this.state.sort
      };
      Object.entries(values).forEach(([key, value]) => {
        if (value) url.searchParams.set(key, value);
        else url.searchParams.delete(key);
      });
      try { window.history.replaceState(window.history.state, '', url.toString()); }
      catch (_) { /* Preview sandboxes may disallow history updates. */ }
    }

    updateOptions() {
      const families = new Map();
      this.records.forEach(record => {
        if (record.family && !families.has(record.family)) families.set(record.family, record.familyLabel || record.family);
      });
      const familyOptions = Array.from(families).sort((a, b) => a[1].localeCompare(b[1], undefined, { sensitivity: 'base' }));
      this.setOptions(this.controls.family, this.labels.allFamilies, familyOptions);
      if (this.state.family && !families.has(this.state.family)) this.state.family = '';
      const designs = new Map();
      this.records.forEach(record => {
        if (record.designKey && !designs.has(record.designKey)) designs.set(record.designKey, record.design || record.designKey);
      });
      const designOptions = Array.from(designs).sort((a, b) => a[1].localeCompare(b[1], undefined, { sensitivity: 'base' }));
      this.setOptions(this.controls.design, this.labels.allDesigns, designOptions);
      if (this.state.design && !designs.has(this.state.design)) this.state.design = '';
    }

    setOptions(select, placeholder, values) {
      if (!select) return;
      const fragment = document.createDocumentFragment();
      [['', placeholder], ...values].forEach(([value, label]) => {
        const option = document.createElement('option');
        option.value = value;
        option.textContent = label;
        fragment.appendChild(option);
      });
      select.replaceChildren(fragment);
    }

    syncControls() {
      Object.entries(this.controls).forEach(([name, control]) => {
        if (!control) return;
        if (name === 'stock') control.checked = this.state.stock;
        else control.value = this.state[name];
      });
    }

    bindEvents(signal) {
      this.addEventListener('click', event => {
        const target = event.target instanceof Element ? event.target : null;
        if (!target) return;
        const family = target.closest('[data-select-family]');
        if (family && this.contains(family)) {
          event.preventDefault();
          const key = family.dataset.selectFamily;
          if (key && !this.familyKeys.has(key)) return;
          this.state.family = this.state.family === key ? '' : key;
          this.syncControls();
          this.change();
          return;
        }
        const design = target.closest('[data-select-design]');
        if (design && this.contains(design)) {
          event.preventDefault();
          const key = design.dataset.selectDesign;
          if (!this.designKeys.has(key)) return;
          this.state.design = this.state.design === key ? '' : key;
          this.syncControls();
          this.change();
          return;
        }
        if (target.closest('[data-reset]')) {
          event.preventDefault();
          this.state = this.defaults();
          this.updateOptions();
          this.syncControls();
          this.change();
          return;
        }
        if (target.closest('[data-show-more]')) {
          event.preventDefault();
          this.limit += 12;
          this.render();
        }
      }, { signal });

      Object.entries(this.controls).forEach(([name, control]) => {
        if (!control) return;
        control.addEventListener(name === 'search' ? 'input' : 'change', () => {
          this.state[name] = name === 'stock' ? control.checked : control.value;
          this.change();
        }, { signal });
      });

      window.addEventListener('popstate', () => {
        this.state = this.readURL();
        this.limit = 12;
        this.updateOptions();
        this.syncControls();
        this.render();
      }, { signal });
    }

    change() {
      this.limit = 12;
      this.render();
      this.writeURL();
    }

    normalize(value) {
      return String(value).normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase().trim();
    }

    format(template, values) {
      return String(template).replace(/\{(\w+)\}/g, (match, key) => Object.hasOwn(values, key) ? String(values[key]) : match);
    }

    render() {
      const state = this.state;
      const terms = this.normalize(state.search).split(/\s+/).filter(Boolean);
      const matches = this.records.filter(record => {
        if (state.family && record.family !== state.family) return false;
        if (state.design && record.designKey !== state.design) return false;
        if (state.stock && !record.available) return false;
        if (terms.length) {
          const text = this.normalize(`${record.title} ${record.familyLabel} ${record.design} ${record.designKey}`);
          if (!terms.every(term => text.includes(term))) return false;
        }
        return true;
      });
      matches.sort((a, b) => {
        if (state.sort === 'price-asc') return a.price - b.price || a.index - b.index;
        if (state.sort === 'price-desc') return b.price - a.price || a.index - b.index;
        if (state.sort === 'name') return a.title.localeCompare(b.title, undefined, { sensitivity: 'base', numeric: true }) || a.index - b.index;
        return Number(b.available) - Number(a.available) || a.index - b.index;
      });

      const visible = new Set(matches.slice(0, this.limit));
      const matchSet = new Set(matches);
      const fragment = document.createDocumentFragment();
      [...matches, ...this.records.filter(record => !matchSet.has(record))].forEach(record => {
        record.element.hidden = !visible.has(record);
        fragment.appendChild(record.element);
      });
      this.grid.appendChild(fragment);

      const count = this.querySelector('[data-result-count]');
      if (count) count.textContent = this.format(matches.length === 1 ? this.labels.countOne : this.labels.count, { count: matches.length });
      const progress = this.querySelector('[data-progress]');
      if (progress) progress.textContent = this.format(this.labels.shown, { shown: visible.size, total: matches.length });
      const more = this.querySelector('[data-show-more]');
      if (more) more.hidden = visible.size >= matches.length;
      const empty = this.querySelector('[data-empty]');
      if (empty) {
        empty.hidden = matches.length !== 0;
        const message = empty.querySelector('[data-empty-message]');
        if (message) message.textContent = this.labels.noResults;
      }

      this.querySelectorAll('[data-select-family]').forEach(button => {
        const selected = button.dataset.selectFamily === state.family;
        button.setAttribute('aria-pressed', selected ? 'true' : 'false');
        button.classList.toggle('is-active', selected);
      });
      this.querySelectorAll('[data-select-design]').forEach(button => {
        const selected = button.dataset.selectDesign === state.design;
        button.setAttribute('aria-pressed', selected ? 'true' : 'false');
        button.classList.toggle('is-active', selected);
      });
    }
  }

  customElements.define('elitex-pro-collection', ElitexProCollection);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elitex-rodilleras-pro"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('elitex-knee-colors')) {
  customElements.define('elitex-knee-colors', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.panels = Array.from(this.querySelectorAll('[data-knee-panel]'));
      this.choices = Array.from(this.querySelectorAll('[data-knee-choice]'));
      if (!this.panels.length || !this.choices.length) return;
      this.controller = new AbortController();
      this.querySelector('[data-color-controls]').hidden = false;
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-knee-choice]');
        if (!button || !this.contains(button)) return;
        this.selectColor(button.dataset.kneeChoice, true);
      }, {signal:this.controller.signal});
      this.addEventListener('shopify:block:select', event => this.selectColor(event.detail.blockId, false), {signal:this.controller.signal});
      this.selectColor(this.panels.find(panel => !panel.hidden)?.dataset.kneePanel || this.panels[0].dataset.kneePanel, false);
    }
    disconnectedCallback() { if (this.controller) this.controller.abort(); this.controller = null; }
    selectColor(id, announce) {
      const selected = this.panels.find(panel => panel.dataset.kneePanel === id);
      const button = this.choices.find(choice => choice.dataset.kneeChoice === id);
      if (!selected || !button) return;
      this.panels.forEach(panel => {panel.hidden = panel !== selected;});
      this.choices.forEach(choice => choice.setAttribute('aria-pressed', String(choice === button)));
      if (this.dataset.followColor === 'true') this.style.setProperty('--exk-tone', button.dataset.tone);
      if (announce) this.querySelector('[data-color-announcement]').textContent = selected.getAttribute('aria-label');
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elitex-selector-mochilas"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('elitex-pack-finder')) {
  customElements.define('elitex-pack-finder', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      const config = this.querySelector('[data-config]');
      if (!config) return;
      try { this.data = JSON.parse(config.textContent); } catch (_) { return; }
      if (!this.data.questions.purpose.title || this.data.questions.purpose.options.some(option => !option[1])) return;
      this.controller = new AbortController();
      this.answers = {}; this.step = 0;
      this.addEventListener('click', event => this.onClick(event), {signal: this.controller.signal});
      this.addEventListener('shopify:block:select', event => this.onEditorSelect(event), {signal: this.controller.signal});
      this.q('fallback').hidden = true; this.q('panel').hidden = false;
      this.renderQuestion(false);
    }
    disconnectedCallback() { if (this.controller) this.controller.abort(); this.controller = null; }
    q(key) { return this.querySelector('[data-' + key + ']'); }
    route() {
      return ['purpose'].concat({gym: ['gymload'], all: ['height'], plane: ['luggage']}[this.answers.purpose] || []);
    }
    updateNext() {
      const route = this.route(), total = this.answers.purpose ? route.length : 2;
      this.q('next').disabled = !this.answers[route[this.step]];
      this.q('next').textContent = this.answers.purpose && this.step === route.length - 1 ? this.data.copy.show : this.data.copy.next;
      this.q('progress').setAttribute('aria-valuemax', String(total));
      this.q('progress').setAttribute('aria-valuenow', String(this.step + 1));
      this.q('progress-fill').style.width = ((this.step + 1) / total * 100) + '%';
    }
    renderQuestion(focus) {
      const key = this.route()[this.step], question = this.data.questions[key];
      this.q('question').hidden = false; this.q('result').hidden = true;
      this.q('next').hidden = false; this.q('reset').hidden = true;
      this.q('back').hidden = this.step === 0; this.q('spacer').hidden = this.step !== 0;
      this.q('step').textContent = this.data.copy.step + ' ' + (this.step + 1) + ' · ' + question.label;
      this.q('question-title').textContent = question.title;
      this.q('options').replaceChildren(...question.options.map(([value, title, detail]) => {
        const button = document.createElement('button'); button.type = 'button';
        button.className = 'exf-choice'; button.dataset.choice = value;
        button.setAttribute('aria-pressed', String(this.answers[key] === value));
        const label = document.createElement('span'); label.textContent = title; button.append(label);
        if (detail) { const small = document.createElement('small'); small.textContent = detail; button.append(small); }
        return button;
      }));
      this.updateNext();
      if (focus) this.q('options').querySelector('button').focus();
      this.q('announcement').textContent = this.q('step').textContent + '. ' + question.title;
    }
    resultKey() {
      const purpose = this.answers.purpose;
      if (purpose === 'gym') return this.answers.gymload === 'light' ? 'gym_light' : 'gym_full';
      if (purpose === 'all') return this.answers.height === 'under170' ? 'all_under' : 'all_from';
      if (purpose === 'plane') return this.answers.luggage === 'cabin' ? 'plane_cabin' : 'plane_checked';
      return purpose;
    }
    paintModel(slot, model) {
      const image = this.q(slot + '-image'), link = this.q(slot + '-link'), title = this.q(slot + '-title');
      image.hidden = !model.image;
      if (model.image) { image.src = model.image; image.alt = model.alt || model.title; }
      else { image.removeAttribute('src'); image.alt = ''; }
      link.href = model.url; link.textContent = model.cta;
      if (title) title.textContent = model.title;
    }
    showResult(key, focus) {
      const rules = {gym_light: ['compact','v2'], gym_full: ['v2','premium'], all_under: ['compact'], all_from: ['v1'], plane_cabin: ['compact','v1','bag'], plane_checked: ['max'], premium: ['premium','v2'], food: ['food']};
      const selected = rules[key]; if (!selected) return;
      const [main, alternative, accessory] = selected, copy = this.data.results[key] || {}, model = this.data.models[main];
      this.paintModel('main', model); this.q('reason').textContent = copy.reason || this.data.copy.fallback;
      this.q('alternative').hidden = !alternative;
      if (alternative) { this.paintModel('alternative', this.data.models[alternative]); this.q('alternative-reason').textContent = copy.alternative || ''; }
      this.q('accessory').hidden = !accessory;
      if (accessory) { this.paintModel('accessory', this.data.models[accessory]); this.q('accessory-description').textContent = this.data.models[accessory].description || ''; }
      this.q('note').hidden = !copy.note; this.q('note').textContent = copy.note || '';
      this.q('question').hidden = true; this.q('result').hidden = false;
      this.q('next').hidden = true; this.q('back').hidden = true;
      this.q('spacer').hidden = true; this.q('reset').hidden = false;
      this.q('progress-fill').style.width = '100%';
      this.q('progress').setAttribute('aria-valuenow', this.q('progress').getAttribute('aria-valuemax'));
      this.q('announcement').textContent = this.data.copy.result + ': ' + model.title + '. ' + this.q('reason').textContent;
      if (focus) this.q('main-link').focus();
    }
    onClick(event) {
      const button = event.target.closest('button'); if (!button || !this.contains(button)) return;
      if (button.hasAttribute('data-choice')) {
        const key = this.route()[this.step], value = button.dataset.choice;
        if (key === 'purpose' && this.answers.purpose !== value) this.answers = {};
        this.answers[key] = value;
        this.q('options').querySelectorAll('button').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        this.updateNext();
      } else if (button.hasAttribute('data-next')) {
        const route = this.route(); if (!this.answers[route[this.step]]) return;
        if (this.step === route.length - 1) this.showResult(this.resultKey(), true);
        else { this.step++; this.renderQuestion(true); }
      } else if (button.hasAttribute('data-back') && this.step > 0) {
        this.step--; this.renderQuestion(true);
      } else if (button.hasAttribute('data-reset')) {
        this.answers = {}; this.step = 0; this.renderQuestion(true);
      }
    }
    onEditorSelect(event) {
      const block = Array.from(this.querySelectorAll('[data-editor-block]')).find(item => item.dataset.editorBlock === event.detail.blockId);
      if (!block) return;
      if (block.dataset.editorType === 'questions') { this.answers = {}; this.step = 0; this.renderQuestion(false); return; }
      const key = block.dataset.editorKey;
      const cases = {compact:'gym_light',v1:'all_from',v2:'gym_full',max:'plane_checked',premium:'premium',food:'food',bag:'plane_cabin'};
      this.showResult(block.dataset.editorType === 'result' ? key : cases[key], false);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elitex-sweat-bands"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('elitex-sweat-story')) {
  customElements.define('elitex-sweat-story', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.addEventListener('click', event => {
        const link = event.target.closest('[data-sw-purchase]');
        if (!link || !this.contains(link) || this.dataset.productContext !== 'true') return;
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
        const variantIds = new Set((this.dataset.variantIds || '').trim().split(/\s+/));
        const nativeForm = Array.from(document.querySelectorAll('form[action*="/cart/add"]')).find(form => {
          const field = form.querySelector('[name="id"]');
          return field && variantIds.has(String(field.value)) && form.getClientRects().length > 0 && !this.contains(form);
        });
        if (!nativeForm) return;
        const control = Array.from(nativeForm.querySelectorAll('button[type="submit"], input[type="submit"], select, input:not([type="hidden"]):not([type="radio"]):not([type="checkbox"]), button')).find(item => !item.disabled && item.getClientRects().length > 0);
        event.preventDefault();
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        nativeForm.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'center' });
        if (control) control.focus({ preventScroll: true });
      }, { signal: this.controller.signal });
      this.addEventListener('shopify:block:select', event => {
        const detail = event.target.closest('details.exsw-question');
        if (detail && this.contains(detail)) detail.open = true;
      }, { signal: this.controller.signal });
    }
    disconnectedCallback() {
      if (this.controller) this.controller.abort();
      this.controller = null;
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elitex-tape-inicio"] && !Shopify.designMode) return;
  try {
    
/* Elitex Tape Inicio: movimiento y cinta interactiva, con eventos limitados a cada instancia. */
(() => {
  if (customElements.get('elitex-tape-home')) return;

  class ElitexTapeHome extends HTMLElement {
    connectedCallback() {
      if (this._abort) return;
      this._abort = new AbortController();
      this._floats = [];
      const signal = this._abort.signal;

      this._reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this._finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
      this._motionButton = this.querySelector('[data-motion-toggle]');
      this._motionChange = () => {
        if (this._motionChoice === undefined) {
          this._setPaused(this._reducedMotion.matches);
        } else if (this._reducedMotion.matches) {
          // A new system preference always stops animation. It never overrides
          // a deliberate pause by automatically starting motion again.
          this._setPaused(true);
        }
        if (this._motionButton) this._motionButton.hidden = this._reducedMotion.matches;
        this._resetTilts();
      };
      if (this._reducedMotion.addEventListener) {
        this._reducedMotion.addEventListener('change', this._motionChange);
      } else {
        this._reducedMotion.addListener(this._motionChange);
      }
      this._setPaused(this._reducedMotion.matches || this._motionChoice === true);
      if (this._motionButton) {
        this._motionButton.addEventListener('click', () => {
          this._motionChoice = !this.classList.contains('eth--paused');
          this._setPaused(this._motionChoice);
        }, { signal });
      }

      this._range = this.querySelector('[data-tape-range]');
      this._stage = this.querySelector('[data-tape-stage]');
      if (this._range && this._stage) {
        this._range.addEventListener('input', () => this._updateRange(), { signal });
        this._updateRange();
      }

      this.querySelectorAll('[data-tape-float]').forEach(element => {
        const state = { element, frame: 0, x: 0, y: 0 };
        this._floats.push(state);
        element.addEventListener('pointermove', event => {
          if (event.pointerType === 'touch' || !this._finePointer.matches ||
              this._reducedMotion.matches || this.classList.contains('eth--paused')) return;
          const rect = element.getBoundingClientRect();
          if (!rect.width || !rect.height) return;
          state.x = Math.max(-4, Math.min(4, ((event.clientY - rect.top) / rect.height - 0.5) * -8));
          state.y = Math.max(-4, Math.min(4, ((event.clientX - rect.left) / rect.width - 0.5) * 8));
          if (state.frame) return;
          state.frame = requestAnimationFrame(() => {
            state.frame = 0;
            element.style.setProperty('--tape-tilt-x', `${state.x.toFixed(2)}deg`);
            element.style.setProperty('--tape-tilt-y', `${state.y.toFixed(2)}deg`);
          });
        }, { signal });
        element.addEventListener('pointerleave', () => this._resetTilt(state), { signal });
        element.addEventListener('pointercancel', () => this._resetTilt(state), { signal });
      });

      // Only reveal controls after their listeners and first state are ready.
      if (this._motionButton) this._motionButton.hidden = this._reducedMotion.matches;
      this.dataset.enhanced = 'true';
    }

    disconnectedCallback() {
      if (this._abort) this._abort.abort();
      this._abort = null;
      if (this._reducedMotion && this._motionChange) {
        if (this._reducedMotion.removeEventListener) {
          this._reducedMotion.removeEventListener('change', this._motionChange);
        } else {
          this._reducedMotion.removeListener(this._motionChange);
        }
      }
      this._resetTilts();
    }

    _setPaused(paused) {
      this.classList.toggle('eth--paused', paused);
      if (this._motionButton) {
        this._motionButton.setAttribute('aria-pressed', String(paused));
        const label = this._motionButton.querySelector('[data-motion-label]');
        const text = paused ? this._motionButton.dataset.playLabel : this._motionButton.dataset.pauseLabel;
        if (label && text) label.textContent = text;
      }
      if (paused) this._resetTilts();
    }

    _updateRange() {
      const value = Math.max(0, Math.min(100, Number(this._range.value) || 0));
      this._stage.style.setProperty('--tape-progress', String(value / 100));
      this._stage.style.setProperty('--tape-turn', `${value * 5}deg`);
      const start = this._range.dataset.valueStart || '';
      const end = this._range.dataset.valueEnd || '';
      const template = this._range.dataset.valueTemplate;
      const description = template ? template.replaceAll('[value]', String(Math.round(value))) :
        value === 0 ? start : value === 100 ? end : `${Math.round(value)}% · ${end}`;
      if (description) this._range.setAttribute('aria-valuetext', description);
    }

    _resetTilt(state) {
      if (state.frame) cancelAnimationFrame(state.frame);
      state.frame = 0;
      state.element.style.setProperty('--tape-tilt-x', '0deg');
      state.element.style.setProperty('--tape-tilt-y', '0deg');
    }

    _resetTilts() {
      (this._floats || []).forEach(state => this._resetTilt(state));
    }
  }

  customElements.define('elitex-tape-home', ElitexTapeHome);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elitex-tape-producto"] && !Shopify.designMode) return;
  try {
    
(()=>{if(customElements.get('elitex-tape-product'))return;customElements.define('elitex-tape-product',class extends HTMLElement{
connectedCallback(){if(this.controller&&!this.controller.signal.aborted)return;this.controller=new AbortController();const signal=this.controller.signal;this.querySelector('[data-slider-label]').hidden=false;this.querySelector('[data-filters]').hidden=false;const range=this.querySelector('[data-unroll]');range.addEventListener('input',()=>{this.querySelector('.etp-ribbon').style.width=range.value+'%';this.querySelector('.etp-reel').style.transform='rotate('+((range.value-65)*2)+'deg)'},{signal});this.addEventListener('click',e=>{const b=e.target.closest('[data-filter]');if(b){const value=b.dataset.filter;this.querySelectorAll('[data-pack]').forEach(c=>c.hidden=value!=='all'&&c.dataset.pack!==value);this.querySelectorAll('[data-filter]').forEach(x=>x.setAttribute('aria-pressed',String(x===b)))}const a=e.target.closest('[data-buy]');if(a&&!e.metaKey&&!e.ctrlKey&&!e.shiftKey&&!e.altKey){const form=Array.from(document.querySelectorAll('form[action*="/cart/add"]')).find(f=>!this.contains(f)&&f.getClientRects().length);if(form){e.preventDefault();form.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'center'});const target=form.querySelector('select, input:not([type="hidden"]), button');if(target)target.focus({preventScroll:true})}}},{signal})}
disconnectedCallback(){this.controller?.abort()}
})})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elitex-v1-45l-coleccion"] && !Shopify.designMode) return;
  try {
    
/* Elitex V1 45 L collection. Prices, availability and images remain server-rendered. */
(() => {
  'use strict';

  if (!window.customElements || customElements.get('elitex-v1-collection')) return;

  class ElitexV1Collection extends HTMLElement {
    connectedCallback() {
      if (this.connectionController && !this.connectionController.signal.aborted) return;
      this.connectionController = new AbortController();
      const signal = this.connectionController.signal;
      this.connect(signal);
    }

    disconnectedCallback() {
      if (this.connectionController) this.connectionController.abort();
    }

    async connect(signal) {
      this.grid = this.querySelector('[data-product-grid]');
      if (!this.grid) return;

      this.labels = {
        count: '{count} diseños',
        countOne: '{count} diseño',
        loading: 'Preparando todos los diseños…',
        loadError: 'No hemos podido preparar los filtros. Puedes explorar los productos a continuación.',
        noResults: 'No hay diseños con estos filtros.',
        shown: '{shown} de {total} diseños',
        loadMore: 'Ver más diseños',
        allDesigns: 'Todos los diseños'
      };
      const labelsNode = this.querySelector('[data-ui-labels]');
      try {
        if (labelsNode) Object.assign(this.labels, JSON.parse(labelsNode.textContent));
      } catch (_) { /* Safe defaults keep the catalogue usable if a label is malformed. */ }

      this.querySelectorAll('[data-select-design]').forEach(button => { button.disabled = true; });
      this.controls = {
        design: this.querySelector('select[data-design]'),
        search: this.querySelector('[data-search]'),
        stock: this.querySelector('[data-stock]'),
        sort: this.querySelector('[data-sort]')
      };

      try {
        if (!this.records) {
          this.setLoading(true);
          const cards = await this.loadAllCards(signal);
          if (signal.aborted) return;
          this.records = cards.map((element, index) => {
            const design = element.dataset.design || '';
            return {
              element,
              index,
              design,
              designKey: element.dataset.designKey || design,
              title: element.dataset.title || '',
              price: Number(element.dataset.price) || 0,
              available: element.dataset.available === 'true'
            };
          });
          this.designKeys = new Set(this.records.map(record => record.designKey));
          this.updateCatalogInfo();
        }

        if (signal.aborted) return;
        this.state = this.readURL();
        this.limit = 12;
        this.updateOptions();
        this.syncControls();
        this.bindEvents(signal);
        this.render();
        this.setLoading(false);
        this.querySelectorAll('[data-tools]').forEach(node => { node.hidden = false; });
        this.querySelectorAll('[data-server-pagination], [data-load-error]').forEach(node => { node.hidden = true; });
        this.querySelectorAll('[data-select-design]').forEach(button => { button.disabled = false; });
        this.dataset.ready = 'true';
      } catch (error) {
        if (signal.aborted) return;
        this.setLoading(false);
        this.querySelectorAll('[data-tools]').forEach(node => { node.hidden = true; });
        this.querySelectorAll('[data-server-pagination]').forEach(node => { node.hidden = false; });
        const errorNode = this.querySelector('[data-load-error]');
        if (errorNode) {
          errorNode.hidden = false;
          const message = errorNode.querySelector('[data-error-message]');
          if (message) message.textContent = this.labels.loadError;
          else if (!errorNode.textContent.trim()) errorNode.textContent = this.labels.loadError;
        }
        this.querySelectorAll('[data-show-more]').forEach(node => { node.hidden = true; });
        Array.from(this.grid.querySelectorAll('[data-product-card]')).forEach(card => { card.hidden = false; });
        delete this.dataset.ready;
      }
    }

    setLoading(loading) {
      this.setAttribute('aria-busy', loading ? 'true' : 'false');
      const status = this.querySelector('[data-load-status]');
      if (status) {
        status.hidden = !loading;
        status.textContent = loading ? this.labels.loading : '';
      }
    }

    async loadAllCards(signal) {
      const initial = Array.from(this.grid.querySelectorAll('[data-product-card]'));
      const pages = Math.max(1, Number.parseInt(this.dataset.pages, 10) || 1);
      const currentPage = Math.max(1, Number.parseInt(this.dataset.page, 10) || 1);
      const expected = Number.parseInt(this.dataset.total, 10);
      const pageCards = new Map([[currentPage, initial]]);

      for (let page = 1; page <= pages; page += 1) {
        if (page === currentPage) continue;
        const url = new URL(window.location.href);
        url.searchParams.set('section_id', this.dataset.sectionId || this.id);
        url.searchParams.set(this.dataset.pageParam || 'page', String(page));
        const response = await fetch(url.toString(), {
          signal,
          credentials: 'same-origin',
          headers: { Accept: 'text/html' }
        });
        if (!response.ok) throw new Error('Could not load a catalogue page.');
        const html = await response.text();
        if (signal.aborted) throw new DOMException('Aborted', 'AbortError');
        const document = new DOMParser().parseFromString(html, 'text/html');
        const sections = Array.from(document.querySelectorAll('elitex-v1-collection'));
        const section = sections.find(node => node.dataset.sectionId === this.dataset.sectionId);
        const grid = section && section.querySelector('[data-product-grid]');
        if (!grid) throw new Error('The catalogue page was incomplete.');
        const cards = Array.from(grid.querySelectorAll('[data-product-card]'));
        if (!cards.length) throw new Error('A catalogue page contained no products.');
        pageCards.set(page, cards);
      }

      const cards = Array.from(pageCards.entries()).sort((a, b) => a[0] - b[0]).flatMap(entry => entry[1]);
      const identifiers = cards.map(card => card.dataset.id).filter(Boolean);
      if (new Set(identifiers).size !== identifiers.length) throw new Error('A catalogue page was repeated.');
      if (Number.isFinite(expected) && cards.length !== expected) throw new Error('The catalogue count changed during loading.');

      // Commit only after every page succeeds; a failure preserves the original server page.
      if (pages > 1) {
        const fragment = window.document.createDocumentFragment();
        cards.forEach(card => { fragment.appendChild(card); });
        this.grid.appendChild(fragment);
      }
      return cards;
    }

    updateCatalogInfo() {
      const available = this.records.filter(record => record.available);
      const pool = available.length ? available : this.records;
      const cheapest = pool.reduce((best, record) => !best || record.price < best.price ? record : best, null);
      const money = cheapest && cheapest.element.querySelector('[data-card-money]');
      this.querySelectorAll('[data-catalog-from]').forEach(node => {
        if (money) node.textContent = money.textContent.trim();
        else node.hidden = true;
      });
      this.querySelectorAll('[data-select-design]').forEach(button => {
        button.hidden = !this.designKeys.has(button.dataset.selectDesign);
      });
    }

    defaults() {
      return { design: '', search: '', stock: false, sort: 'featured' };
    }

    readURL() {
      const params = new URL(window.location.href).searchParams;
      const state = this.defaults();
      state.design = params.get('ex_design') || '';
      state.search = params.get('ex_search') || '';
      state.stock = params.get('ex_stock') === '1';
      const sort = params.get('ex_sort');
      state.sort = ['featured', 'price-asc', 'price-desc', 'name'].includes(sort) ? sort : 'featured';
      return state;
    }

    writeURL() {
      const url = new URL(window.location.href);
      const values = {
        ex_design: this.state.design,
        ex_search: this.state.search,
        ex_stock: this.state.stock ? '1' : '',
        ex_sort: this.state.sort === 'featured' ? '' : this.state.sort
      };
      Object.entries(values).forEach(([key, value]) => {
        if (value) url.searchParams.set(key, value);
        else url.searchParams.delete(key);
      });
      try { window.history.replaceState(window.history.state, '', url.toString()); }
      catch (_) { /* Preview sandboxes may disallow history updates. */ }
    }

    updateOptions() {
      const designs = new Map();
      this.records.forEach(record => {
        if (record.designKey && !designs.has(record.designKey)) designs.set(record.designKey, record.design || record.designKey);
      });
      const designOptions = Array.from(designs).sort((a, b) => a[1].localeCompare(b[1], undefined, { sensitivity: 'base' }));
      this.setOptions(this.controls.design, this.labels.allDesigns, designOptions);
      if (this.state.design && !designs.has(this.state.design)) this.state.design = '';
    }

    setOptions(select, placeholder, values) {
      if (!select) return;
      const fragment = document.createDocumentFragment();
      [['', placeholder], ...values].forEach(([value, label]) => {
        const option = document.createElement('option');
        option.value = value;
        option.textContent = label;
        fragment.appendChild(option);
      });
      select.replaceChildren(fragment);
    }

    syncControls() {
      Object.entries(this.controls).forEach(([name, control]) => {
        if (!control) return;
        if (name === 'stock') control.checked = this.state.stock;
        else control.value = this.state[name];
      });
    }

    bindEvents(signal) {
      this.addEventListener('click', event => {
        const target = event.target instanceof Element ? event.target : null;
        if (!target) return;
        const design = target.closest('[data-select-design]');
        if (design && this.contains(design)) {
          event.preventDefault();
          const key = design.dataset.selectDesign;
          if (!this.designKeys.has(key)) return;
          this.state.design = this.state.design === key ? '' : key;
          this.syncControls();
          this.change();
          return;
        }
        if (target.closest('[data-reset]')) {
          event.preventDefault();
          this.state = this.defaults();
          this.updateOptions();
          this.syncControls();
          this.change();
          return;
        }
        if (target.closest('[data-show-more]')) {
          event.preventDefault();
          this.limit += 12;
          this.render();
        }
      }, { signal });

      Object.entries(this.controls).forEach(([name, control]) => {
        if (!control) return;
        control.addEventListener(name === 'search' ? 'input' : 'change', () => {
          this.state[name] = name === 'stock' ? control.checked : control.value;
          this.change();
        }, { signal });
      });

      window.addEventListener('popstate', () => {
        this.state = this.readURL();
        this.limit = 12;
        this.updateOptions();
        this.syncControls();
        this.render();
      }, { signal });
    }

    change() {
      this.limit = 12;
      this.render();
      this.writeURL();
    }

    normalize(value) {
      return String(value).normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase().trim();
    }

    format(template, values) {
      return String(template).replace(/\{(\w+)\}/g, (match, key) => Object.hasOwn(values, key) ? String(values[key]) : match);
    }

    render() {
      const state = this.state;
      const terms = this.normalize(state.search).split(/\s+/).filter(Boolean);
      const matches = this.records.filter(record => {
        if (state.design && record.designKey !== state.design) return false;
        if (state.stock && !record.available) return false;
        if (terms.length) {
          const text = this.normalize(`${record.title} ${record.design} ${record.designKey}`);
          if (!terms.every(term => text.includes(term))) return false;
        }
        return true;
      });
      matches.sort((a, b) => {
        if (state.sort === 'price-asc') return a.price - b.price || a.index - b.index;
        if (state.sort === 'price-desc') return b.price - a.price || a.index - b.index;
        if (state.sort === 'name') return a.title.localeCompare(b.title, undefined, { sensitivity: 'base', numeric: true }) || a.index - b.index;
        return Number(b.available) - Number(a.available) || a.index - b.index;
      });

      const visible = new Set(matches.slice(0, this.limit));
      const matchSet = new Set(matches);
      const fragment = document.createDocumentFragment();
      [...matches, ...this.records.filter(record => !matchSet.has(record))].forEach(record => {
        record.element.hidden = !visible.has(record);
        fragment.appendChild(record.element);
      });
      this.grid.appendChild(fragment);

      const count = this.querySelector('[data-result-count]');
      if (count) count.textContent = this.format(matches.length === 1 ? this.labels.countOne : this.labels.count, { count: matches.length });
      const progress = this.querySelector('[data-progress]');
      if (progress) progress.textContent = this.format(this.labels.shown, { shown: visible.size, total: matches.length });
      const more = this.querySelector('[data-show-more]');
      if (more) more.hidden = visible.size >= matches.length;
      const empty = this.querySelector('[data-empty]');
      if (empty) {
        empty.hidden = matches.length !== 0;
        const message = empty.querySelector('[data-empty-message]');
        if (message) message.textContent = this.labels.noResults;
      }

      this.querySelectorAll('[data-select-design]').forEach(button => {
        const selected = button.dataset.selectDesign === state.design;
        button.setAttribute('aria-pressed', selected ? 'true' : 'false');
        button.classList.toggle('is-active', selected);
      });
    }
  }

  customElements.define('elitex-v1-collection', ElitexV1Collection);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elitex-v2-45l-coleccion"] && !Shopify.designMode) return;
  try {
    
/* Elitex V2 45 L collection. Prices, availability and images remain server-rendered. */
(() => {
  'use strict';

  if (!window.customElements || customElements.get('elitex-v245-collection')) return;

  class ElitexV245Collection extends HTMLElement {
    connectedCallback() {
      if (this.connectionController && !this.connectionController.signal.aborted) return;
      this.connectionController = new AbortController();
      const signal = this.connectionController.signal;
      this.connect(signal);
    }

    disconnectedCallback() {
      if (this.connectionController) this.connectionController.abort();
    }

    async connect(signal) {
      this.grid = this.querySelector('[data-product-grid]');
      if (!this.grid) return;

      this.labels = {
        count: '{count} diseños',
        countOne: '{count} diseño',
        loading: 'Preparando todos los diseños…',
        loadError: 'No hemos podido preparar los filtros. Puedes explorar los productos a continuación.',
        noResults: 'No hay diseños con estos filtros.',
        shown: '{shown} de {total} diseños',
        loadMore: 'Ver más diseños',
        allDesigns: 'Todos los diseños',
        allFamilies: 'Todos los modelos'
      };
      const labelsNode = this.querySelector('[data-ui-labels]');
      try {
        if (labelsNode) Object.assign(this.labels, JSON.parse(labelsNode.textContent));
      } catch (_) { /* Safe defaults keep the catalogue usable if a label is malformed. */ }

      this.querySelectorAll('[data-select-design], [data-select-family]').forEach(button => { button.disabled = true; });
      this.controls = {
        family: this.querySelector('select[data-family]'),
        design: this.querySelector('select[data-design]'),
        search: this.querySelector('[data-search]'),
        stock: this.querySelector('[data-stock]'),
        sort: this.querySelector('[data-sort]')
      };

      try {
        if (!this.records) {
          this.setLoading(true);
          const cards = await this.loadAllCards(signal);
          if (signal.aborted) return;
          this.records = cards.map((element, index) => {
            const design = element.dataset.design || '';
            return {
              element,
              index,
              design,
              family: element.dataset.family || 'other',
              familyLabel: element.dataset.familyLabel || element.dataset.family || '',
              designKey: element.dataset.designKey || design,
              title: element.dataset.title || '',
              price: Number(element.dataset.price) || 0,
              available: element.dataset.available === 'true'
            };
          });
          this.designKeys = new Set(this.records.map(record => record.designKey));
          this.familyKeys = new Set(this.records.map(record => record.family));
          this.updateCatalogInfo();
        }

        if (signal.aborted) return;
        this.state = this.readURL();
        this.limit = 12;
        this.updateOptions();
        this.syncControls();
        this.bindEvents(signal);
        this.render();
        this.setLoading(false);
        this.querySelectorAll('[data-tools]').forEach(node => { node.hidden = false; });
        this.querySelectorAll('[data-server-pagination], [data-load-error]').forEach(node => { node.hidden = true; });
        this.querySelectorAll('[data-select-design], [data-select-family]').forEach(button => { button.disabled = false; });
        this.dataset.ready = 'true';
      } catch (error) {
        if (signal.aborted) return;
        this.setLoading(false);
        this.querySelectorAll('[data-tools]').forEach(node => { node.hidden = true; });
        this.querySelectorAll('[data-server-pagination]').forEach(node => { node.hidden = false; });
        const errorNode = this.querySelector('[data-load-error]');
        if (errorNode) {
          errorNode.hidden = false;
          const message = errorNode.querySelector('[data-error-message]');
          if (message) message.textContent = this.labels.loadError;
          else if (!errorNode.textContent.trim()) errorNode.textContent = this.labels.loadError;
        }
        this.querySelectorAll('[data-show-more]').forEach(node => { node.hidden = true; });
        Array.from(this.grid.querySelectorAll('[data-product-card]')).forEach(card => { card.hidden = false; });
        delete this.dataset.ready;
      }
    }

    setLoading(loading) {
      this.setAttribute('aria-busy', loading ? 'true' : 'false');
      const status = this.querySelector('[data-load-status]');
      if (status) {
        status.hidden = !loading;
        status.textContent = loading ? this.labels.loading : '';
      }
    }

    async loadAllCards(signal) {
      const initial = Array.from(this.grid.querySelectorAll('[data-product-card]'));
      const pages = Math.max(1, Number.parseInt(this.dataset.pages, 10) || 1);
      const currentPage = Math.max(1, Number.parseInt(this.dataset.page, 10) || 1);
      const expected = Number.parseInt(this.dataset.total, 10);
      const pageCards = new Map([[currentPage, initial]]);

      for (let page = 1; page <= pages; page += 1) {
        if (page === currentPage) continue;
        const url = new URL(window.location.href);
        url.searchParams.set('section_id', this.dataset.sectionId || this.id);
        url.searchParams.set(this.dataset.pageParam || 'page', String(page));
        const response = await fetch(url.toString(), {
          signal,
          credentials: 'same-origin',
          headers: { Accept: 'text/html' }
        });
        if (!response.ok) throw new Error('Could not load a catalogue page.');
        const html = await response.text();
        if (signal.aborted) throw new DOMException('Aborted', 'AbortError');
        const document = new DOMParser().parseFromString(html, 'text/html');
        const sections = Array.from(document.querySelectorAll('elitex-v245-collection'));
        const section = sections.find(node => node.dataset.sectionId === this.dataset.sectionId);
        const grid = section && section.querySelector('[data-product-grid]');
        if (!grid) throw new Error('The catalogue page was incomplete.');
        const cards = Array.from(grid.querySelectorAll('[data-product-card]'));
        if (!cards.length) throw new Error('A catalogue page contained no products.');
        pageCards.set(page, cards);
      }

      const cards = Array.from(pageCards.entries()).sort((a, b) => a[0] - b[0]).flatMap(entry => entry[1]);
      const identifiers = cards.map(card => card.dataset.id).filter(Boolean);
      if (new Set(identifiers).size !== identifiers.length) throw new Error('A catalogue page was repeated.');
      if (Number.isFinite(expected) && cards.length !== expected) throw new Error('The catalogue count changed during loading.');

      // Commit only after every page succeeds; a failure preserves the original server page.
      if (pages > 1) {
        const fragment = window.document.createDocumentFragment();
        cards.forEach(card => { fragment.appendChild(card); });
        this.grid.appendChild(fragment);
      }
      return cards;
    }

    updateCatalogInfo() {
      const available = this.records.filter(record => record.available);
      const pool = available.length ? available : this.records;
      const cheapest = pool.reduce((best, record) => !best || record.price < best.price ? record : best, null);
      const money = cheapest && cheapest.element.querySelector('[data-card-money]');
      this.querySelectorAll('[data-catalog-from]').forEach(node => {
        if (money) node.textContent = money.textContent.trim();
        else node.hidden = true;
      });
      this.querySelectorAll('[data-select-design]').forEach(button => {
        button.hidden = !this.designKeys.has(button.dataset.selectDesign);
      });
      this.querySelectorAll('[data-select-family]').forEach(button => {
        button.hidden = Boolean(button.dataset.selectFamily) && !this.familyKeys.has(button.dataset.selectFamily);
      });
    }

    defaults() {
      return { family: '', design: '', search: '', stock: false, sort: 'featured' };
    }

    readURL() {
      const params = new URL(window.location.href).searchParams;
      const state = this.defaults();
      state.family = params.get('e245_family') || '';
      state.design = params.get('e245_design') || '';
      state.search = params.get('e245_search') || '';
      state.stock = params.get('e245_stock') === '1';
      const sort = params.get('e245_sort');
      state.sort = ['featured', 'price-asc', 'price-desc', 'name'].includes(sort) ? sort : 'featured';
      return state;
    }

    writeURL() {
      const url = new URL(window.location.href);
      const values = {
        e245_family: this.state.family,
        e245_design: this.state.design,
        e245_search: this.state.search,
        e245_stock: this.state.stock ? '1' : '',
        e245_sort: this.state.sort === 'featured' ? '' : this.state.sort
      };
      Object.entries(values).forEach(([key, value]) => {
        if (value) url.searchParams.set(key, value);
        else url.searchParams.delete(key);
      });
      try { window.history.replaceState(window.history.state, '', url.toString()); }
      catch (_) { /* Preview sandboxes may disallow history updates. */ }
    }

    updateOptions() {
      const families = new Map();
      this.records.forEach(record => {
        if (record.family && !families.has(record.family)) families.set(record.family, record.familyLabel || record.family);
      });
      const familyOptions = Array.from(families).sort((a, b) => a[1].localeCompare(b[1], undefined, { sensitivity: 'base' }));
      this.setOptions(this.controls.family, this.labels.allFamilies, familyOptions);
      if (this.state.family && !families.has(this.state.family)) this.state.family = '';
      const designs = new Map();
      this.records.forEach(record => {
        if (record.designKey && !designs.has(record.designKey)) designs.set(record.designKey, record.design || record.designKey);
      });
      const designOptions = Array.from(designs).sort((a, b) => a[1].localeCompare(b[1], undefined, { sensitivity: 'base' }));
      this.setOptions(this.controls.design, this.labels.allDesigns, designOptions);
      if (this.state.design && !designs.has(this.state.design)) this.state.design = '';
    }

    setOptions(select, placeholder, values) {
      if (!select) return;
      const fragment = document.createDocumentFragment();
      [['', placeholder], ...values].forEach(([value, label]) => {
        const option = document.createElement('option');
        option.value = value;
        option.textContent = label;
        fragment.appendChild(option);
      });
      select.replaceChildren(fragment);
    }

    syncControls() {
      Object.entries(this.controls).forEach(([name, control]) => {
        if (!control) return;
        if (name === 'stock') control.checked = this.state.stock;
        else control.value = this.state[name];
      });
    }

    bindEvents(signal) {
      this.addEventListener('click', event => {
        const target = event.target instanceof Element ? event.target : null;
        if (!target) return;
        const family = target.closest('[data-select-family]');
        if (family && this.contains(family)) {
          event.preventDefault();
          const key = family.dataset.selectFamily;
          if (key && !this.familyKeys.has(key)) return;
          this.state.family = this.state.family === key ? '' : key;
          this.syncControls();
          this.change();
          return;
        }
        const design = target.closest('[data-select-design]');
        if (design && this.contains(design)) {
          event.preventDefault();
          const key = design.dataset.selectDesign;
          if (!this.designKeys.has(key)) return;
          this.state.design = this.state.design === key ? '' : key;
          this.syncControls();
          this.change();
          return;
        }
        if (target.closest('[data-reset]')) {
          event.preventDefault();
          this.state = this.defaults();
          this.updateOptions();
          this.syncControls();
          this.change();
          return;
        }
        if (target.closest('[data-show-more]')) {
          event.preventDefault();
          this.limit += 12;
          this.render();
        }
      }, { signal });

      Object.entries(this.controls).forEach(([name, control]) => {
        if (!control) return;
        control.addEventListener(name === 'search' ? 'input' : 'change', () => {
          this.state[name] = name === 'stock' ? control.checked : control.value;
          this.change();
        }, { signal });
      });

      window.addEventListener('popstate', () => {
        this.state = this.readURL();
        this.limit = 12;
        this.updateOptions();
        this.syncControls();
        this.render();
      }, { signal });
    }

    change() {
      this.limit = 12;
      this.render();
      this.writeURL();
    }

    normalize(value) {
      return String(value).normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase().trim();
    }

    format(template, values) {
      return String(template).replace(/\{(\w+)\}/g, (match, key) => Object.hasOwn(values, key) ? String(values[key]) : match);
    }

    render() {
      const state = this.state;
      const terms = this.normalize(state.search).split(/\s+/).filter(Boolean);
      const matches = this.records.filter(record => {
        if (state.family && record.family !== state.family) return false;
        if (state.design && record.designKey !== state.design) return false;
        if (state.stock && !record.available) return false;
        if (terms.length) {
          const text = this.normalize(`${record.title} ${record.familyLabel} ${record.design} ${record.designKey}`);
          if (!terms.every(term => text.includes(term))) return false;
        }
        return true;
      });
      matches.sort((a, b) => {
        if (state.sort === 'price-asc') return a.price - b.price || a.index - b.index;
        if (state.sort === 'price-desc') return b.price - a.price || a.index - b.index;
        if (state.sort === 'name') return a.title.localeCompare(b.title, undefined, { sensitivity: 'base', numeric: true }) || a.index - b.index;
        return Number(b.available) - Number(a.available) || a.index - b.index;
      });

      const visible = new Set(matches.slice(0, this.limit));
      const matchSet = new Set(matches);
      const fragment = document.createDocumentFragment();
      [...matches, ...this.records.filter(record => !matchSet.has(record))].forEach(record => {
        record.element.hidden = !visible.has(record);
        fragment.appendChild(record.element);
      });
      this.grid.appendChild(fragment);

      const count = this.querySelector('[data-result-count]');
      if (count) count.textContent = this.format(matches.length === 1 ? this.labels.countOne : this.labels.count, { count: matches.length });
      const progress = this.querySelector('[data-progress]');
      if (progress) progress.textContent = this.format(this.labels.shown, { shown: visible.size, total: matches.length });
      const more = this.querySelector('[data-show-more]');
      if (more) more.hidden = visible.size >= matches.length;
      const empty = this.querySelector('[data-empty]');
      if (empty) {
        empty.hidden = matches.length !== 0;
        const message = empty.querySelector('[data-empty-message]');
        if (message) message.textContent = this.labels.noResults;
      }

      this.querySelectorAll('[data-select-family]').forEach(button => {
        const selected = button.dataset.selectFamily === state.family;
        button.setAttribute('aria-pressed', selected ? 'true' : 'false');
        button.classList.toggle('is-active', selected);
      });
      this.querySelectorAll('[data-select-design]').forEach(button => {
        const selected = button.dataset.selectDesign === state.design;
        button.setAttribute('aria-pressed', selected ? 'true' : 'false');
        button.classList.toggle('is-active', selected);
      });
    }
  }

  customElements.define('elitex-v245-collection', ElitexV245Collection);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elitex-v2-45l"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('elitex-v2-story')) {
  customElements.define('elitex-v2-story', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.addEventListener('click', event => {
        const link = event.target.closest('[data-v2-purchase]');
        if (!link || !this.contains(link) || this.dataset.productContext !== 'true') return;
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
        const variantIds = new Set((this.dataset.variantIds || '').trim().split(/\s+/));
        const nativeForm = Array.from(document.querySelectorAll('form[action*="/cart/add"]')).find(form => {
          const field = form.querySelector('[name="id"]');
          return field && variantIds.has(String(field.value)) && form.getClientRects().length > 0 && !this.contains(form);
        });
        if (!nativeForm) return;
        const control = Array.from(nativeForm.querySelectorAll('button[type="submit"], input[type="submit"], select, input:not([type="hidden"]):not([type="radio"]):not([type="checkbox"]), button')).find(item => !item.disabled && item.getClientRects().length > 0);
        event.preventDefault();
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        nativeForm.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'center' });
        if (control) control.focus({ preventScroll: true });
      }, { signal: this.controller.signal });
      this.addEventListener('shopify:block:select', event => {
        const detail = event.target.closest('details.exv2-question');
        if (detail && this.contains(detail)) detail.open = true;
      }, { signal: this.controller.signal });
    }
    disconnectedCallback() {
      if (this.controller) this.controller.abort();
      this.controller = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elitex-vision-one-coleccion"] && !Shopify.designMode) return;
  try {
    
/* Elitex Vision One collection. Prices, availability and images remain server-rendered. */
(() => {
  'use strict';

  if (!window.customElements || customElements.get('elitex-vision-collection')) return;

  class ElitexVisionCollection extends HTMLElement {
    connectedCallback() {
      if (this.connectionController && !this.connectionController.signal.aborted) return;
      this.connectionController = new AbortController();
      const signal = this.connectionController.signal;
      this.connect(signal);
    }

    disconnectedCallback() {
      if (this.connectionController) this.connectionController.abort();
    }

    async connect(signal) {
      // The visual selector remains usable even if a later catalogue page fails.

      this.grid = this.querySelector('[data-product-grid]');
      if (!this.grid) return;

      this.labels = {
        count: '{count} productos',
        countOne: '{count} producto',
        loading: 'Preparando el catálogo…',
        loadError: 'No hemos podido preparar los filtros. Puedes explorar los productos a continuación.',
        noResults: 'No hay productos con estos filtros.',
        shown: '{shown} de {total} productos',
        loadMore: 'Ver más productos',
        allFamilies: 'Todos los modelos'
      };
      const labelsNode = this.querySelector('[data-ui-labels]');
      try {
        if (labelsNode) Object.assign(this.labels, JSON.parse(labelsNode.textContent));
      } catch (_) { /* Safe defaults keep the catalogue usable if a label is malformed. */ }

      this.querySelectorAll('[data-select-family]').forEach(button => { button.disabled = true; });
      this.controls = {
        search: this.querySelector('[data-search]'),
        stock: this.querySelector('[data-stock]'),
        sort: this.querySelector('[data-sort]')
      };

      try {
        if (!this.records) {
          this.setLoading(true);
          const cards = await this.loadAllCards(signal);
          if (signal.aborted) return;
          this.records = cards.map((element, index) => {
            const design = element.dataset.design || '';
            return {
              element,
              index,
              design,
              family: element.dataset.family || 'unknown',
              familyLabel: element.dataset.familyLabel || element.dataset.family || '',
              designKey: element.dataset.designKey || design,
              title: element.dataset.title || '',
              variantText: element.dataset.variantSearch || '',
              price: Number(element.dataset.price) || 0,
              available: element.dataset.available === 'true'
            };
          });
          this.familyKeys = new Set(this.records.map(record => record.family));
          this.updateCatalogInfo();
        }

        if (signal.aborted) return;
        this.state = this.readURL();
        this.limit = 12;
        this.updateOptions();
        this.syncControls();
        this.bindEvents(signal);
        this.render();
        this.setLoading(false);
        this.querySelectorAll('[data-tools]').forEach(node => { node.hidden = false; });
        this.querySelectorAll('[data-server-pagination], [data-load-error]').forEach(node => { node.hidden = true; });
        this.querySelectorAll('[data-select-family]').forEach(button => { button.disabled = false; });
        this.dataset.ready = 'true';
      } catch (error) {
        if (signal.aborted) return;
        this.setLoading(false);
        this.querySelectorAll('[data-tools]').forEach(node => { node.hidden = true; });
        this.querySelectorAll('[data-server-pagination]').forEach(node => { node.hidden = false; });
        const errorNode = this.querySelector('[data-load-error]');
        if (errorNode) {
          errorNode.hidden = false;
          const message = errorNode.querySelector('[data-error-message]');
          if (message) message.textContent = this.labels.loadError;
          else if (!errorNode.textContent.trim()) errorNode.textContent = this.labels.loadError;
        }
        this.querySelectorAll('[data-show-more]').forEach(node => { node.hidden = true; });
        Array.from(this.grid.querySelectorAll('[data-product-card]')).forEach(card => { card.hidden = false; });
        delete this.dataset.ready;
      }
    }

    setLoading(loading) {
      this.setAttribute('aria-busy', loading ? 'true' : 'false');
      const status = this.querySelector('[data-load-status]');
      if (status) {
        status.hidden = !loading;
        status.textContent = loading ? this.labels.loading : '';
      }
    }

    async loadAllCards(signal) {
      const initial = Array.from(this.grid.querySelectorAll('[data-product-card]'));
      const pages = Math.max(1, Number.parseInt(this.dataset.pages, 10) || 1);
      const currentPage = Math.max(1, Number.parseInt(this.dataset.page, 10) || 1);
      const expected = Number.parseInt(this.dataset.total, 10);
      const pageCards = new Map([[currentPage, initial]]);

      for (let page = 1; page <= pages; page += 1) {
        if (page === currentPage) continue;
        const url = new URL(window.location.href);
        url.searchParams.set('section_id', this.dataset.sectionId || this.id);
        url.searchParams.set(this.dataset.pageParam || 'page', String(page));
        const response = await fetch(url.toString(), {
          signal,
          credentials: 'same-origin',
          headers: { Accept: 'text/html' }
        });
        if (!response.ok) throw new Error('Could not load a catalogue page.');
        const html = await response.text();
        if (signal.aborted) throw new DOMException('Aborted', 'AbortError');
        const document = new DOMParser().parseFromString(html, 'text/html');
        const sections = Array.from(document.querySelectorAll('elitex-vision-collection'));
        const section = sections.find(node => node.dataset.sectionId === this.dataset.sectionId);
        const grid = section && section.querySelector('[data-product-grid]');
        if (!grid) throw new Error('The catalogue page was incomplete.');
        const cards = Array.from(grid.querySelectorAll('[data-product-card]'));
        if (!cards.length) throw new Error('A catalogue page contained no products.');
        pageCards.set(page, cards);
      }

      const cards = Array.from(pageCards.entries()).sort((a, b) => a[0] - b[0]).flatMap(entry => entry[1]);
      const identifiers = cards.map(card => card.dataset.id).filter(Boolean);
      if (new Set(identifiers).size !== identifiers.length) throw new Error('A catalogue page was repeated.');
      if (Number.isFinite(expected) && cards.length !== expected) throw new Error('The catalogue count changed during loading.');

      // Commit only after every page succeeds; a failure preserves the original server page.
      if (pages > 1) {
        const fragment = window.document.createDocumentFragment();
        cards.forEach(card => { fragment.appendChild(card); });
        this.grid.appendChild(fragment);
      }
      return cards;
    }

    updateCatalogInfo() {
      const available = this.records.filter(record => record.available);
      const pool = available.length ? available : this.records;
      const cheapest = pool.reduce((best, record) => !best || record.price < best.price ? record : best, null);
      const money = cheapest && cheapest.element.querySelector('[data-card-money]');
      this.querySelectorAll('[data-catalog-from]').forEach(node => {
        if (money) node.textContent = money.textContent.trim();
        else node.hidden = true;
      });
      this.querySelectorAll('[data-select-family]').forEach(button => {
        button.hidden = Boolean(button.dataset.selectFamily) && !this.familyKeys.has(button.dataset.selectFamily);
      });
    }

    defaults() {
      return { family: '', search: '', stock: false, sort: 'featured' };
    }

    readURL() {
      const params = new URL(window.location.href).searchParams;
      const state = this.defaults();
      state.family = params.get('evc_family') || '';
      state.search = params.get('evc_search') || '';
      state.stock = params.get('evc_stock') === '1';
      const sort = params.get('evc_sort');
      state.sort = ['featured', 'price-asc', 'price-desc', 'name'].includes(sort) ? sort : 'featured';
      return state;
    }

    writeURL() {
      const url = new URL(window.location.href);
      const values = {
        evc_family: this.state.family,
        evc_search: this.state.search,
        evc_stock: this.state.stock ? '1' : '',
        evc_sort: this.state.sort === 'featured' ? '' : this.state.sort
      };
      Object.entries(values).forEach(([key, value]) => {
        if (value) url.searchParams.set(key, value);
        else url.searchParams.delete(key);
      });
      try { window.history.replaceState(window.history.state, '', url.toString()); }
      catch (_) { /* Preview sandboxes may disallow history updates. */ }
    }

    updateOptions() {
      if (this.state.family && !this.familyKeys.has(this.state.family)) this.state.family = '';
    }

    syncControls() {
      Object.entries(this.controls).forEach(([name, control]) => {
        if (!control) return;
        if (name === 'stock') control.checked = this.state.stock;
        else control.value = this.state[name];
      });
    }

    bindEvents(signal) {
      this.addEventListener('click', event => {
        const target = event.target instanceof Element ? event.target : null;
        if (!target) return;
        const family = target.closest('[data-select-family]');
        if (family && this.contains(family)) {
          event.preventDefault();
          const key = family.dataset.selectFamily;
          if (key && !this.familyKeys.has(key)) return;
          this.state.family = key;
          this.state.search = '';
          if (!key) this.state.stock = false;
          this.syncControls();
          this.change();
          return;
        }
        if (target.closest('[data-reset]')) {
          event.preventDefault();
          this.state = this.defaults();
          this.updateOptions();
          this.syncControls();
          this.change();
          return;
        }
        if (target.closest('[data-show-more]')) {
          event.preventDefault();
          this.limit += 12;
          this.render();
        }
      }, { signal });

      Object.entries(this.controls).forEach(([name, control]) => {
        if (!control) return;
        control.addEventListener(name === 'search' ? 'input' : 'change', () => {
          this.state[name] = name === 'stock' ? control.checked : control.value;
          this.change();
        }, { signal });
      });

      window.addEventListener('popstate', () => {
        this.state = this.readURL();
        this.limit = 12;
        this.updateOptions();
        this.syncControls();
        this.render();
      }, { signal });
    }

    change() {
      this.limit = 12;
      this.render();
      this.writeURL();
    }

    normalize(value) {
      return String(value).normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase().trim();
    }

    format(template, values) {
      return String(template).replace(/\{(\w+)\}/g, (match, key) => Object.hasOwn(values, key) ? String(values[key]) : match);
    }

    render() {
      const state = this.state;
      const terms = this.normalize(state.search).split(/\s+/).filter(Boolean);
      const matches = this.records.filter(record => {
        if (state.family && record.family !== state.family) return false;
        if (state.stock && !record.available) return false;
        if (terms.length) {
          const text = this.normalize(`${record.title} ${record.variantText} ${record.familyLabel} ${record.design} ${record.designKey}`);
          if (!terms.every(term => text.includes(term))) return false;
        }
        return true;
      });
      matches.sort((a, b) => {
        if (state.sort === 'price-asc') return a.price - b.price || a.index - b.index;
        if (state.sort === 'price-desc') return b.price - a.price || a.index - b.index;
        if (state.sort === 'name') return a.title.localeCompare(b.title, undefined, { sensitivity: 'base', numeric: true }) || a.index - b.index;
        return a.index - b.index;
      });

      const visible = new Set(matches.slice(0, this.limit));
      const matchSet = new Set(matches);
      const fragment = document.createDocumentFragment();
      [...matches, ...this.records.filter(record => !matchSet.has(record))].forEach(record => {
        record.element.hidden = !visible.has(record);
        fragment.appendChild(record.element);
      });
      this.grid.appendChild(fragment);

      const count = this.querySelector('[data-result-count]');
      if (count) count.textContent = this.format(matches.length === 1 ? this.labels.countOne : this.labels.count, { count: matches.length });
      const progress = this.querySelector('[data-progress]');
      if (progress) progress.textContent = this.format(this.labels.shown, { shown: visible.size, total: matches.length });
      const more = this.querySelector('[data-show-more]');
      if (more) more.hidden = visible.size >= matches.length;
      const empty = this.querySelector('[data-empty]');
      if (empty) {
        empty.hidden = matches.length !== 0;
        const message = empty.querySelector('[data-empty-message]');
        if (message) message.textContent = this.labels.noResults;
      }

      this.querySelectorAll('[data-select-family]').forEach(button => {
        const selected = button.dataset.selectFamily === state.family;
        button.setAttribute('aria-pressed', selected ? 'true' : 'false');
        button.classList.toggle('is-active', selected);
      });
    }
  }

  customElements.define('elitex-vision-collection', ElitexVisionCollection);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elitex-vision-one"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('elitex-vision-one')) {
  customElements.define('elitex-vision-one', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.addEventListener('click', event => {
        const link = event.target.closest('[data-vo-purchase]');
        if (!link || !this.contains(link) || this.dataset.productContext !== 'true') return;
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
        const variantIds = new Set((this.dataset.variantIds || '').trim().split(/\s+/));
        const nativeForm = Array.from(document.querySelectorAll('form[action*="/cart/add"]')).find(form => {
          const field = form.querySelector('[name="id"]');
          return field && variantIds.has(String(field.value)) && form.getClientRects().length > 0 && !this.contains(form);
        });
        if (!nativeForm) return;
        const control = Array.from(nativeForm.querySelectorAll('button[type="submit"], input[type="submit"], select, input:not([type="hidden"]):not([type="radio"]):not([type="checkbox"]), button')).find(item => !item.disabled && item.getClientRects().length > 0);
        event.preventDefault();
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        nativeForm.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'center' });
        if (control) control.focus({ preventScroll: true });
      }, { signal: this.controller.signal });
      this.addEventListener('shopify:block:select', event => {
        const detail = event.target.closest('details.exvo-question');
        if (detail && this.contains(detail)) detail.open = true;
      }, { signal: this.controller.signal });
    }
    disconnectedCallback() {
      if (this.controller) this.controller.abort();
      this.controller = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();
})();
